import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { Card } from '../components/Card';
import { Input } from '../components/Input';
import { Select } from '../components/Select';
import { Tooltip } from "@mui/material";
import Modal from '../../components/common/CommonModal';
import { Trash2, Search, PenSquare, Printer, Plus, Building2 } from 'lucide-react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import CreditCustomerList from '../../components/common/CreditCustomerList';
import { useContractCalculations } from './hooks/userContractCalculations'
import { calculateFinanceTotals } from './hooks/userfinanceCalculations'
import RecieptView from '../../RecieptFolder/RecieptView';
import RecieptViewRE from './ReceiptViewRE';

export default function TenancyContractRegister() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'contract_info');
  const [saving, setSaving] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeModalField, setActiveModalField] = useState(null);
  const [selectedPropertyType, setSelectedPropertyType] = useState("-");
  const [selectedStatus, setSelectedStatus] = useState("Vacant");
  const [selectedUnitType, setSelectedUnitType] = useState("-");
  const [tenantModalOpen, setTenantModalOpen] = useState(false);
  const [unitModalOpen, setUnitModalOpen] = useState(false);
  const [units, setUnits] = useState([]);
  const [unitsLoading, setUnitsLoading] = useState(false);
  const [unitSearch, setUnitSearch] = useState('');
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [selectedUnitForSplit, setSelectedUnitForSplit] = useState(null);
  const [showSplitPanel, setShowSplitPanel] = useState(false);
  const [hasUnits, setHasUnits] = useState(false);
  const [buildings, setBuildings] = useState([]);

  const [selectedBuildingID, setSelectedBuildingID] = useState(location.state?.buildingId || '1');
  const [selectedBuilding, setSelectedBuilding] = useState([]);
  const [loadingBuildings, setLoadingBuildings] = useState(false);
  const [incomeBreakupModalOpen, setIncomeBreakupModalOpen] = useState(false);
  const [showMonthsAccordion, setShowMonthsAccordion] = useState(false);
  const [rentAllocationDesc, setRentAllocationDesc] = useState("");
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateContractNo, setDuplicateContractNo] = useState("");

  const currentUserfromLocal = JSON.parse(localStorage.getItem("currentUser"))
  const vatPfromLocal = currentUserfromLocal[0].vatp
  const currencyFromLocal = currentUserfromLocal[0].CURRENCY
  const vatp = vatPfromLocal;
  const [data, setData] = useState({
    header: {
      contractNo: location.state?.contractNo || '',
      date: new Date().toISOString().split("T")[0],
      status: 'APPROVED',
      type: 'NEW',
      oldServiceCharge: '0.00',
    },
    contract: {
      building: 'Al Manarah',
      tenancyType: 'RESIDENTIAL',
      periodFrom: '2026-01-01',
      periodTo: '2027-01-01',
      subject: '',
      terms: '',
      modeOfPay: '',
      tenantName: '',
      tenantAccount: '',
      tenantTRN: '',
      rent: 0,
      vatPercent: vatp,

      deposit: 0,
      serviceCharge: 0,
      serviceVatPercent: 0,
      discount: 0,
      ejariFee: 0,
      ejariVat: 0,
      otherFee: 0,
      parkingFee: 0,
      commissionFee: 0,
      preSettled: 0,
      rentVat: 0,
      commissionVat: 0,
      grossPayable: '',
      observation1: '',
      observation2: '',
      observation3: '',
      observation4: '',
      observation5: '',
      observation6: '',
      observation7: '',
      observation8: ''
    },
    rentAlloc: {
      totalIncome: '',
      invoiceNumber: 'INV-1050',
      rows: []
    },
    settlement: {
      settlementDate: '2027-07-02',
      vacatingDate: '2027-07-02',
      total: '',
      rent: '',
      grossPeriod: '',
      cancellationFee: '0.00',
      cancellationRef: '',
      repairingCharge: '0.00',
      repairingRef: '',
      electricityWaterDue: '0.00',
      elecWaterRef: '',
      otherCharges: '0.00',
      otherRef: '',
      settleAmount: '0.00',
      accountMap: '2900',
      balance: '-2900',
      settle: '',
      account: '',
      ledger: [
        { slno: 1, pvNum: 'PV-2001', date: '2027-07-02', desc: 'Security Deposit Refund', amount: 14575, chqNo: '789012', chqDate: '2027-07-05', bank: '11030001', type: 'BANK' },
        { slno: 2, pvNum: 'PV-2002', date: '2027-07-02', desc: 'Cancellation Fee Deduction', amount: 0, chqNo: '', chqDate: '', bank: '11030001', type: 'ADJ' }
      ]
    },
    receipts: {
      date: new Date().toISOString().split("T")[0],
      vrNo: '1008',
      printFormat: 'receipt_single',
      rows: [
        { slno: 1, rvNum: '1008', date: '2026-07-02', desc: 'Rent Deposit CHQ 1', amount: 14575, chqNo: '343434', chqDate: '2026-08-04', bank: '11030001', type: 'PDC' },
        { slno: 2, rvNum: '1008', date: '2026-07-02', desc: 'Rent Deposit CHQ 2', amount: 14575, chqNo: '545454', chqDate: '2026-10-04', bank: '11030001', type: 'PDC' }
      ]
    },
    logistics: {
      shopId: '',
      elecMeterNo: '', elecOpenReading: '0', elecMeterCharge: '0.00', elecRate: '0.00',
      waterMeterNo: '', waterOpenReading: '0', waterMeterCharge: '0.00', waterRate: '0.00'
    },
    printSelection: 'P1',
    relatedDocs: []
  });



  useEffect(() => {
    fetchAccountList("CUSTOMERS");
    fetchBuildings();
  }, []);

  useEffect(() => {
    if (location.state?.contractNo) {
      fetchContractDetails(location.state.contractNo);
    }
  }, [location.state?.contractNo]);

  useEffect(() => {
    console.log("selectedUnits:", selectedUnits)
  }, [selectedUnits]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showMonthsAccordion && !event.target.closest('.relative')) {
        setShowMonthsAccordion(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showMonthsAccordion]);

  const update = useCallback((section, field, value) => {
    setData(prev => ({
      ...prev,
      [section]: { ...prev[section], [field]: value }
    }));
  }, []);

  const dateMetrics = useMemo(() => {
    const from = new Date(data.contract.periodFrom);
    const to = new Date(data.contract.periodTo);
    if (isNaN(from) || isNaN(to) || to < from) return { years: 0, months: 0, days: 0 };
    let years = to.getFullYear() - from.getFullYear();
    let months = to.getMonth() - from.getMonth();
    let days = to.getDate() - from.getDate();
    if (days < 0) { months -= 1; days += new Date(to.getFullYear(), to.getMonth(), 0).getDate(); }
    if (months < 0) { years -= 1; months += 12; }
    const lastDayOfToMonth = new Date(to.getFullYear(), to.getMonth() + 1, 0).getDate();
    const isLastDay = to.getDate() === lastDayOfToMonth;
    if (days > 0 && isLastDay) { months += 1; days = 0; }
    if (months >= 12) { years += Math.floor(months / 12); months = months % 12; }
    if (days === 0 && !isLastDay) { days += 1; }
    return { years, months, days };
  }, [data.contract.periodFrom, data.contract.periodTo]);

  const generatedRentRows = useMemo(() => {
    const totalIncome = Number(data.rentAlloc.totalIncome) || 0;
    const from = new Date(data.contract.periodFrom);
    const to = new Date(data.contract.periodTo);
    if (isNaN(from) || isNaN(to) || to < from || totalIncome <= 0) return [];

    const totalDays = Math.ceil((to - from) / (1000 * 60 * 60 * 24)) + 1;
    const dailyRate = totalIncome / totalDays;

    const rows = [];
    const tenantName = data.contract.tenantName || 'Tenant';
    const invoiceNo = data.rentAlloc.invoiceNumber || '';
    let allocated = 0;
    let cursor = new Date(from);

    while (cursor <= to) {
      const year = cursor.getFullYear();
      const month = cursor.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);

      const periodStart = cursor < firstDay ? firstDay : cursor;
      const periodEnd = to < lastDay ? to : lastDay;
      const daysInPeriod = Math.ceil((periodEnd - periodStart) / (1000 * 60 * 60 * 24)) + 1;

      const isLastMonth = periodEnd.getTime() >= to.getTime();
      const amount = isLastMonth
        ? Math.round((totalIncome - allocated) * 1000) / 1000
        : Math.round(dailyRate * daysInPeriod * 1000) / 1000;

      const startStr = `${String(periodStart.getDate()).padStart(2, '0')}-${String(periodStart.getMonth() + 1).padStart(2, '0')}-${periodStart.getFullYear()}`;
      const endStr = `${String(periodEnd.getDate()).padStart(2, '0')}-${String(periodEnd.getMonth() + 1).padStart(2, '0')}-${periodEnd.getFullYear()}`;
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      rows.push({
        pdate: `${year}-${String(month + 1).padStart(2, '0')}-01`,
        desc: `${tenantName}/Rent ${startStr} to ${endStr}`,
        amount,
        voucherNo: invoiceNo,
      });

      allocated += amount;
      cursor = new Date(year, month + 1, 1);
    }

    return rows;
  }, [data.rentAlloc.totalIncome, data.rentAlloc.invoiceNumber, data.contract.periodFrom, data.contract.periodTo, data.contract.tenantName]);

  const rentAllocRows = useMemo(() => {
    if (generatedRentRows.length > 0) return generatedRentRows;
    return data.rentAlloc.rows;
  }, [generatedRentRows, data.rentAlloc.rows]);


  useEffect(() => {
    fetchInvoiceNo()
  }, [])

  const [invoiceNoFromAPI, setInvoiceNoFromAPI] = useState('INV-1')

  useEffect(() => {
    if (invoiceNoFromAPI) {
      update('rentAlloc', 'invoiceNumber', invoiceNoFromAPI);
    }
  }, [invoiceNoFromAPI]);

  const fetchInvoiceNo = async () => {
    try {
      const apiPathsLocal = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      const companyCodeLocal = localStorage.getItem("companyCode") || "-";
      let department = localStorage.getItem("currentSelectedDepartment") || "-";

      const voucherRes = await axios.get(`${apiPathsLocal[0]?.API_CONFIG}/api/CRMVoucherSettings/${companyCodeLocal}/VOUCHERNUMBERS/${department}/GET/SI-R/-`);
      // https://cubixweberp.com:213/api/CRMVoucherSettings/SUNRISEWEB/VOUCHERNUMBERS/MAIN/GET/IS-CA/-
      const nextNo = voucherRes.data?.[0]?.NEXT_NO || '1';
      setInvoiceNoFromAPI(`INV-${nextNo}`)
      console.log("nextNo:", nextNo)
      // invNum = `${nextNo}`;
    } catch (err) {
      console.error("Error fetching voucher number:", err);
    }
  }

  // const fetchVoucherNo = async () => {
  //   let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
  //   let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GetNew/${selectedVoucherType}/-`;

  //   try {
  //     const response = await axios.get(apiUrl);
  //     const voucherNo = response.data[0].NEXT_NO;
  //     setDisableModify(false);
  //     setPVnoFromAPI(voucherNo || "");
  //     setMaxVoucherNo(voucherNo || "");

  //     fetchVoucherTimeline(voucherNo);
  //   } catch (err) {
  //     console.error("Error while fetching Voucher No:", err);
  //   }
  // };


  console.log("invoiceNoFromAPI:", invoiceNoFromAPI)

  const fetchContractDetails = async (contractNo) => {
    if (!contractNo || !contractNo.trim()) return;
    try {
      const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      const companyCode = localStorage.getItem("companyCode") || "SUNRISEWEB";
      const url = `${apiPaths[0]?.API_CONFIG}/api/DocumentEditDetails/${companyCode}/CONTRACT/${contractNo.trim()}/-`;
      const res = await axios.get(url);
      const c = Array.isArray(res.data) ? res.data[0] : res.data;
      if (!c) { alert("No contract found for number: " + contractNo); return; }

      const formatDate = (val) => {
        if (!val) return '';
        return val.split('T')[0];
      };

      setData(prev => ({
        ...prev,
        header: {
          ...prev.header,
          contractNo: c.contractNo || prev.header.contractNo,
          date: formatDate(c.ContDate) || prev.header.date,
          status: c.Status || prev.header.status,
          type: prev.header.type || 'NEW',
          oldServiceCharge: String(c.oldService || 0),
        },
        contract: {
          ...prev.contract,
          building: c.Building || prev.contract.building,
          tenancyType: c.Type || prev.contract.tenancyType,
          periodFrom: formatDate(c.PeriodFrom) || prev.contract.periodFrom,
          periodTo: formatDate(c.PeriodTo) || prev.contract.periodTo,
          subject: c.Subject || '',
          terms: c.terms || '',
          tenantName: c.Tenant || '',
          tenantAccount: c.Account || '',
          tenantTRN: c.TRN || '',
          rent: Number(c.Rent) || 0,
          deposit: Number(c.Deposit) || 0,
          discount: Number(c.DepositUnit) || 0,
          commissionFee: Number(c.Commission || c.commi) || 0,
          ejariFee: Number(c.MaintSplit) || 0,
          parkingFee: Number(c.GasSplit) || 0,
          otherFee: Number(c.OthersSplit) || 0,
          serviceCharge: Number(c.TaxSplit) || 0,
          preSettled: Number(c.presettled) || 0,
          rentVat: Number(c.RentVat) || 0,
          commissionVatAmt: Number(c.CommissionVat) || 0,
          grossPayable: String(c.set_GrossPayable || ''),
          observation1: c.OBS1 || '',
          observation2: c.OBS2 || '',
          observation3: c.OBS3 || '',
          observation4: c.OBS4 || '',
          observation5: c.OBS5 || '',
          observation6: c.OBS6 || '',
          observation7: c.OBS7 || '',
          observation8: c.OBS8 || '',
        },
        settlement: {
          ...prev.settlement,
          settlementDate: formatDate(c.settlementDt) || prev.settlement.settlementDate,
          vacatingDate: formatDate(c.set_VacatingDt) || prev.settlement.vacatingDate,
          cancellationFee: String(c.set_cancelFee || 0),
          cancellationRef: String(c.set_CancelRef || ''),
          repairingCharge: String(c.set_RepMaintFee || 0),
          repairingRef: String(c.set_RepMaintRef || ''),
          electricityWaterDue: String(c.set_EleWaterFee || 0),
          elecWaterRef: String(c.set_EleWaterRef || ''),
          otherCharges: String(c.set_OtherFee || 0),
          otherRef: String(c.set_OtherRef || ''),
        },
        logistics: {
          ...prev.logistics,
          shopId: c.ShopID || '',
          elecMeterNo: c.EMeterNo || '',
          elecOpenReading: String(c.EPrevReading || 0),
          elecMeterCharge: String(c.EMeterCharge || 0),
          elecRate: String(c.ERate || 0),
          waterMeterNo: c.WMeterNo || '',
          waterOpenReading: String(c.WPrevReading || 0),
          waterMeterCharge: String(c.WMeterCharge || 0),
          waterRate: String(c.WRate || 0),
        },
        rentAlloc: {
          ...prev.rentAlloc,
          invoiceNumber: c.INVNO || prev.rentAlloc.invoiceNumber,
        },
      }));

      if (c.Building) {
        setSelectedBuildingID(String(c.Building));
      }

      setFinanceTotals(prev => ({
        ...prev,
        vatAmt: Number(c.RentVat) || prev.vatAmt,
        commissionVatAmt: Number(c.CommissionVat) || prev.commissionVatAmt,
        grossTotal: Number(c.set_GrossPayable) || prev.grossTotal,
      }));

    } catch (err) {
      console.error("Error fetching contract details:", err);
      alert("Failed to fetch contract details. Please check the contract number.");
    }
  };

  const checkDuplicateContract = async (contractNo) => {
    if (!contractNo || !contractNo.trim()) return;
    try {
      const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      const companyCode = localStorage.getItem("companyCode") || "SUNRISEWEB";
      const url = `${apiPaths[0]?.API_CONFIG}/api/DupCheck/${companyCode}/CONTRACT/${contractNo.trim()}`;
      const res = await axios.get(url);
      const count = res.data?.[0]?.COUNT ?? 0;
      if (count > 0) {
        setDuplicateContractNo(contractNo.trim());
        setShowDuplicateModal(true);
      } else {
        fetchContractDetails(contractNo);
      }
    } catch (err) {
      console.error("Error checking duplicate contract:", err);
      fetchContractDetails(contractNo);
    }
  };

  const saveContractInformation = useCallback(async () => {
    if (!data.header.contractNo || !data.header.contractNo.trim()) {
      alert('Contract number is required. Please enter a contract number before saving.');
      return;
    }
    setSaving(true);
    try {
      let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      let companyCode = localStorage.getItem("companyCode") || "-";
      let department = localStorage.getItem("currentSelectedDepartment") || "-";
      let currentUserName = localStorage.getItem("currentUserName") || "admin";
      const now = new Date().toISOString();





      const isEdit = !!location.state?.contractNo || (data.header.status === 'APPROVED' && data.header.type !== 'NEW');

      const unitIds = selectedUnits.map(u => u.UnitID || u.unit_id || '').filter(Boolean).join(',');

      const calculatedResults = calculate()

      const payload = [{
        CmpCode: companyCode,
        mode: isEdit ? 'EDIT' : 'ENTRY',
        contractNo: data.header.contractNo || '',
        ContDate: data.header.date || '',
        Status: "Active",
        Status: data.header.status || '',
        Building: selectedBuildingID || '',
        Type: data.contract.tenancyType || '',
        Period: data.contract.modeOfPay || '',
        PeriodFrom: data.contract.periodFrom || '',
        PeriodTo: data.contract.periodTo || '',
        Subject: data.contract.subject || '',
        terms: data.contract.terms || '',
        Tenant: data.contract.tenantName || '',
        Account: data.contract.tenantAccount || '',
        TRN: data.contract.tenantTRN || '',
        Observations: "",
        Rent: Number(data.contract.rent) || 0,
        RentVat: data.contract.rentVat || financeTotals.vatAmt || 0,
        Deposit: Number(data.contract.deposit) || 0,
        Commission: Number(data.contract.commissionFee) || 0,
        CommissionVat: data.contract.commissionVat || Number(financeTotals.commissionVatAmt) || 0,
        RvNum: "0",
        InvNum: String(data.contract.selectedUnits || "0"),
        comments: currentUserName,
        CURR_STATUS: "APPROVED",//pending
        RV_DATE: new Date().toISOString(),
        INVNO: invoiceNoFromAPI || "0",
        APPROVAL:  data.header.status || '',
        OBS1: data.contract.observation1 || null,
        OBS2: data.contract.observation2 || null,
        OBS3: data.contract.observation3 || null,
        OBS4: data.contract.observation4 || null,
        OBS5: data.contract.observation5 || null,
        OBS6: data.contract.observation6 || null,
        OBS7: data.contract.observation7 || null,
        OBS8: data.contract.observation8 || null,
        ContractNoOld: "CON-2025-0012",//pending
        ENDDT: data.contract.endingDate || data.contract.periodTo || '',
        oldService: Number(data.header.oldServiceCharge) || 0, //pending
        RentUnit: Number(data.contract.rent) || 0,
        DepositUnit: Number(data.contract.discount) || 0,
        CommissionUnit: Number(data.contract.commissionFee) || 0,
        RentSplit: Number(data.contract.rent) || 0, //---->Rent without VAT
        TaxSplit: Number(data.contract.serviceCharge) || 0, //---> service charge without vat  
        MaintSplit: Number(data.contract.ejariFee) || 0, //--->ejari without vat
        DewaSplit: Number(data.contract.commissionFee) || 0, //--->commission without vat
        GasSplit: Number(data.contract.parkingFee) || 0, // parking fee
        OthersSplit: Number(data.contract.otherFee) || 0, // other fee
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        settlementDt: data.settlement.settlementDate || null,
        set_VacatingDt: data.settlement.vacatingDate || null,
        set_totalRent: calculatedResults.totalRent || null, //totalRent ? netRent
        set_RentforPeriod: calculatedResults.rentForPeriod || null,
        set_GrossPayable: data.contract.grossPayable || calculatedResults.grossTotal || null,
        set_Years: Number(dateMetrics.years) || 0,
        set_months: Number(dateMetrics.months) || 0,
        set_days: Number(dateMetrics.days) || 0,
        set_cancelFee: String(Number(data.settlement.cancellationFee) || 0),
        set_CancelRef: String(data.settlement.cancellationRef) || 0,
        set_RepMaintFee: String(Number(data.settlement.repairingCharge) || 0),
        set_RepMaintRef: String(data.settlement.repairingRef) || 0,
        set_EleWaterFee: String(Number(data.settlement.electricityWaterDue) || 0),
        set_EleWaterRef: String(data.settlement.elecWaterRef) || 0,
        set_OtherFee: String(Number(data.settlement.otherCharges) || 0),
        set_OtherRef: String(data.settlement.otherRef) || 0,
        set_TotalCharges: String((Number(data.settlement.cancellationFee) || 0) + (Number(data.settlement.repairingCharge) || 0) + (Number(data.settlement.electricityWaterDue) || 0) + (Number(data.settlement.otherCharges) || 0)),
        set_AmtRefund: "0.00",//pending
        set_Round: "0.00",//pending
        set_NetPayable: "0.00",//pending
        T_YEARS: Number(dateMetrics.years) || 0,
        T_MONTHS: Number(dateMetrics.months) || 0,
        T_DAYS: Number(dateMetrics.days) || 0,
        no_rooms: "",//pending
        TaxPerc: "",//pending
        DEWA: "",//pending
        commi: Number(data.contract.commissionFee) || 0, //pending
        ejari: Number(data.contract.ejariFee) + (financeTotals.ejariVat || 0), //-->ejari with vat
        inclVat: "Yes", //pending 
        presettled: Number(data.contract.preSettled) || 0, //pending 
        ShopID: data.logistics.shopId || "",
        EMeterNo: data.logistics.elecMeterNo || "",
        EPrevReading: Number(data.logistics.elecOpenReading) || 0,
        EMeterCharge: Number(data.logistics.elecMeterCharge) || 0,
        ERate: Number(data.logistics.elecRate) || 0,
        WMeterNo: data.logistics.waterMeterNo || "",
        WPrevReading: Number(data.logistics.waterOpenReading) || 0,
        WMeterCharge: Number(data.logistics.waterMeterCharge) || 0,
        WRate: Number(data.logistics.waterRate) || 0,
        invoiceDesc: rentAllocationDesc,


        // Discount: Number(data.contract.discount) || 0,//pending

      }];

      console.log('Contract Information Save Payload:', JSON.stringify(payload, null, 2));

      const response = await axios.post(
        `${apiPaths[0]?.API_CONFIG}/api/TenancyContract`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );

      console.log('Contract Information Save Response:', response.data);
      alert('Contract information saved successfully!');
    } catch (error) {
      console.error('Error saving contract information:', error);
      alert('Failed to save contract information: ' + (error.response?.data?.message || error.message));
    } finally {
      setSaving(false);
    }

    const payload1 = {
      "CmpCode": "SUNRISEWEB",
      "mode": "ENTRY",
      "contractNo": "CON-2026-0089",
      "ContDate": "2026-07-21T00:00:00Z",
      "Status": "Active",
      "Building": "BLD-XYZ-01",
      "Type": "Commercial",
      "Period": "1 Year",
      "PeriodFrom": "2026-08-01T00:00:00Z",
      "PeriodTo": "2027-07-31T23:59:59Z",
      "Subject": "Office 402 Lease Agreement",
      "terms": "Standard annual corporate lease terms with 4 post-dated cheques.",
      "Tenant": "Acme Corporation Ltd",
      "Account": "12050001",
      "TRN": "100234567800003",
      "Observations": "Requires carpet cleaning prior to occupancy.",
      "Rent": Number(data.contract.rent) || 0,
      "RentVat": Number(financeTotals.vatAmt) || 0,
      "Deposit": Number(data.contract.deposit) || 0,
      "Commission": 7500.00,
      "CommissionVat": 375.00,
      "RvNum": "RV-889912",
      "InvNum": "INV-776655",
      "comments": "Approved by Regional Director.",
      "CURR_STATUS": "APPROVED",
      "RV_DATE": "2026-07-21T10:34:19Z",
      "INVNO": "0",
      "APPROVAL": "YES",
      "OBS1": null,
      "OBS2": null,
      "OBS3": null,
      "OBS4": null,
      "OBS5": null,
      "OBS6": null,
      "OBS7": null,
      "OBS8": null,
      "ContractNoOld": "CON-2025-0012",
      "ENDDT": "2027-07-31T00:00:00Z",
      "oldService": 2500.00,
      "RentUnit": Number(data.contract.rent) || 0,
      "DepositUnit": Number(data.contract.deposit) || 0,
      "CommissionUnit": Number(data.contract.commissionFee) || 0,
      "RentSplit": 12500.00,
      "TaxSplit": 625.00,
      "MaintSplit": 500.00,
      "DewaSplit": 200.00,
      "GasSplit": 0.00,
      "OthersSplit": 0.00,
      "img1": "",
      "img2": "",
      "img3": "",
      "img4": "",
      "img5": "",
      "settlementDt": null,
      "set_VacatingDt": null,
      "set_totalRent": null,
      "set_RentforPeriod": null,
      "set_GrossPayable": null,
      "set_Years": "1",
      "set_months": "0",
      "set_days": "0",
      "set_cancelFee": "0.00",
      "set_CancelRef": "",
      "set_RepMaintFee": "0.00",
      "set_RepMaintRef": "",
      "set_EleWaterFee": "0.00",
      "set_EleWaterRef": "",
      "set_OtherFee": "0.00",
      "set_OtherRef": "",
      "set_TotalCharges": "0.00",
      "set_AmtRefund": "0.00",
      "set_Round": "0.00",
      "set_NetPayable": "0.00",
      "T_YEARS": "1",
      "T_MONTHS": "0",
      "T_DAYS": "0",
      "no_rooms": "3",
      "TaxPerc": "5",
      "DEWA": "99881122",
      "commi": Number(data.contract.commissionFee) || 0,
      "ejari": 220.00,
      "inclVat": "Yes",
      "presettled": 0.00,
      "ShopID": "SHOP-402",
      "EMeterNo": "E-402-99",
      "EPrevReading": 12450.00,
      "EMeterCharge": 0.00,
      "ERate": 0.38,
      "WMeterNo": "W-402-99",
      "WPrevReading": 4500.00,
      "WMeterCharge": 0.00,
      "WRate": 0.12,
      "invoiceDesc": "First installment invoice for Office 402"
    }

  }, [data, selectedBuildingID, selectedUnits]);

  const handleTenantSelect = (selectedAccount) => {
    console.log("Selected Account:", selectedAccount)
    update('contract', 'tenantName', selectedAccount.DESCRIPTION || selectedAccount.AccountName || selectedAccount.name || '');
    update('contract', 'tenantAccount', selectedAccount.ACCOUNT || selectedAccount.AccountCode || selectedAccount.code || '');
    update('contract', 'tenantAccountCode', selectedAccount.ACCOUNT || selectedAccount.AccountCode || selectedAccount.code || '');
    update('contract', 'tenantTRN', selectedAccount.TRN || '');
    update('contract', 'tenantAmount', selectedAccount.BALANCE || '');
    setTenantModalOpen(false);
  };

  const clearTenantField = () => {
    update('contract', 'tenantName', '');
    update('contract', 'tenantAccount', '');
    update('contract', 'tenantAccountCode', '');
    update('contract', 'tenantTRN', '');
  };

  useEffect(() => {
    console.log("data.contract.selectedUnits:", data.contract.selectedUnits)
    const dataP = (selectedUnits || [])
      .map(unit => unit.UnitID)
      .join(',')
    console.log("data.contract.selectedUnits data:", dataP)
  }, [data.contract.selectedUnits])

  const fetchUnits = async () => {
    setUnitsLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    try {
      // const res = await axios.get(`${apiPaths[0]?.API_CONFIG}/api/UnitMaster/${companyCode}`);
      let url = `${apiPaths[0]?.API_CONFIG}/api/CRMTaskMainListFilter/${companyCode}/UNITBUILDING/${selectedPropertyType}/-/${selectedStatus}/${selectedBuildingID}/-/1900-01-01/1900-01-01/-/${selectedUnitType}/1`;
      // let url = `${apiPaths[0]?.API_CONFIG}/api/CRMTaskMainListFilter/${companyCode}/UNITBUILDING/-/-/Vacant/12/-/1900-01-01/1900-01-01/-/-/1`;
      const res = await axios.get(url);

      setUnits(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching units:", err);
      setUnits([]);
    } finally {
      setUnitsLoading(false);
    }
  };

  const handleOpenUnitModal = () => {
    fetchUnits();
    setUnitModalOpen(true);
  };

  const handleAddUnit = (unit) => {
    const unitExists = selectedUnits.some(u => (u.UnitID || u.unit_id) === (unit.UnitID || unit.unit_id));
    if (!unitExists) {
      setSelectedUnits(prev => [...prev, unit]);
    }
    setUnitModalOpen(false);
  };

  const handleRemoveUnit = (unitId) => {
    setSelectedUnits(prev => prev.filter(u => (u.UnitID || u.unit_id) !== unitId));
    if (selectedUnitForSplit && (selectedUnitForSplit.UnitID || selectedUnitForSplit.unit_id) === unitId) {
      setSelectedUnitForSplit(null);
      setShowSplitPanel(false);
    }
  };

  const handleUnitFieldChange = (unitId, field, value) => {
    setSelectedUnits(prev => prev.map(u => {
      if ((u.UnitID || u.unit_id) === unitId) {
        return { ...u, [field]: Number(value) || 0 };
      }
      return u;
    }));
  };

  const handleSplitRent = () => {
    if (!selectedUnitForSplit) return;
    const rentInput = Number(data.contract.subRent) || 0;
    if (rentInput <= 0) return;

    const from = new Date(data.contract.periodFrom);
    const to = new Date(data.contract.periodTo);
    const totalDays = Math.ceil((to - from) / (1000 * 60 * 60 * 24)) + 1;
    console.log("totalDays:", totalDays)
    const dailyRent = rentInput / totalDays;
    console.log("dailyRent:", dailyRent)
    const monthlyRent = dailyRent * 30;

    setSelectedUnits(prev => prev.map(u => {
      if ((u.UnitID || u.unit_id) === (selectedUnitForSplit.UnitID || selectedUnitForSplit.unit_id)) {
        return { ...u, MonthlyRent: Math.round(monthlyRent * 100) / 100, DailyRent: Math.round(dailyRent * 100) / 100 };
      }
      return u;
    }));
    // setSelectedUnits(prev => prev.map(u => {
    //   if ((u.UnitID || u.unit_id) === (selectedUnitForSplit.UnitID || selectedUnitForSplit.unit_id)) {
    //     return { ...u, MonthlyRent: Math.round(dailyRent * 100) / 100, DailyRent: Math.round(dailyRent * 100) / 100 };
    //   }
    //   return u;
    // }));

    update('contract', 'rent', rentInput);
    setSelectedUnitForSplit(null);
    setShowSplitPanel(false);
    update('contract', 'subRent', '');
  };

  const handleSplitSCharge = () => {
    if (!selectedUnitForSplit) return;
    const schargeInput = Number(data.contract.subSCharge) || 0;
    if (schargeInput <= 0) return;

    const from = new Date(data.contract.periodFrom);
    const to = new Date(data.contract.periodTo);
    const totalDays = Math.ceil((to - from) / (1000 * 60 * 60 * 24)) + 1;
    const dailySCharge = schargeInput / totalDays;
    const monthlySCharge = dailySCharge * 30;

    setSelectedUnits(prev => prev.map(u => {
      if ((u.UnitID || u.unit_id) === (selectedUnitForSplit.UnitID || selectedUnitForSplit.unit_id)) {
        return { ...u, ServiceCharge: Math.round(dailySCharge * 100) / 100, DailyServiceCharge: Math.round(dailySCharge * 100) / 100 };
      }
      return u;
    }));

    update('contract', 'serviceCharge', schargeInput);
    setSelectedUnitForSplit(null);
    setShowSplitPanel(false);
    update('contract', 'subSCharge', '');
  };

  const filteredUnits = useMemo(() => {
    if (!unitSearch.trim()) return units;
    const q = unitSearch.toLowerCase();
    return units.filter(u =>
      (u.UnitID || '').toLowerCase().includes(q) ||
      (u.UnitNo || '').toLowerCase().includes(q) ||
      (u.UnitName || '').toLowerCase().includes(q) ||
      (u.UnitType || '').toLowerCase().includes(q) ||
      (u.UnitStatus || '').toLowerCase().includes(q)
    );
  }, [units, unitSearch]);

  const fetchBuildings = async () => {
    setLoadingBuildings(true);
    const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    const companyCode = localStorage.getItem("companyCode") || "-";
    try {
      const res = await axios.get(`${apiPaths[0]?.API_CONFIG}/api/CRMTaskMainListFilter/${companyCode}/BUILDING/-/-/-/-/-/1900-01-01/1900-01-01/-/-/-`);
      const data = Array.isArray(res.data) ? res.data : [];
      setBuildings(data);
      if (data.length > 0 && !selectedBuildingID) {
        setSelectedBuildingID(data[0].BuildingID);
      }
    } catch (err) {
      console.error('Failed to fetch buildings:', err);
    } finally {
      setLoadingBuildings(false);
    }
  };





  const fetchAccountList = async (valueToAPI) => {
    setLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";


    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMAccountList/${companyCode}/ACCOUNTLIST/${department}/${valueToAPI}/-/-`;

    try {
      const response = await axios.get(apiUrl);
      setAccounts(response.data || []);
    } catch (err) {
      console.error("Error while fetching voucher accounts", err);
    } finally {
      setLoading(false);
    }
  };




  useEffect(() => {
    if (selectedBuildingID && buildings?.length) {
      const building = buildings.find(
        (b) => String(b.BuildingID) === String(selectedBuildingID)
      );
      setSelectedBuilding(building || null);
    }
  }, [selectedBuildingID, buildings]);

  const checkBuildingHasUnits = async () => {
    if (!selectedBuildingID) { setHasUnits(false); return; }
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    try {
      const url = `${apiPaths[0]?.API_CONFIG}/api/CRMTaskMainListFilter/${companyCode}/UNITBUILDING/${selectedPropertyType}/-/${selectedStatus}/${selectedBuildingID}/-/1900-01-01/1900-01-01/-/${selectedUnitType}/1`;
      const res = await axios.get(url);
      setHasUnits(Array.isArray(res.data) && res.data.length > 0);
    } catch {
      setHasUnits(false);
    }
  };

  useEffect(() => {
    if (selectedBuildingID) checkBuildingHasUnits();
    else setHasUnits(false);
  }, [selectedBuildingID]);




  const incomeBreakupData = useMemo(() => {
    const b = selectedBuilding || {};
    const contract = data.contract;
    return [
      {
        desc: "RENT",
        amount: Number(contract.rent).toFixed(3) || 0,
        incomeAc: b.RentalIncomeAccount || '',
        prepaidAc: b.RentalIncomeAccountPP || '',
        percent: 0,
      },
      {
        desc: "SERVICE",
        amount: Number(contract.serviceCharge) || 0,
        incomeAc: b.MaintenanceIncomeAccount || '',
        prepaidAc: b.MaintenanceIncomeAccountPP || '',
        percent: 0,
      },
      {
        desc: "EJARI",
        amount: Number(contract.ejariFee) || 0,
        incomeAc: b.EjariIncomeAccount || '',
        prepaidAc: b.EjariIncomeAccountPP || '',
        percent: 0,
      },
      {
        desc: "COMMISSION",
        amount: Number(contract.commissionFee) || 0,
        incomeAc: b.CommissionIncomeAccount || '',
        prepaidAc: b.CommissionIncomeAccountPP || '',
        percent: 0,
      },
      {
        desc: "PARKING",
        amount: Number(contract.parkingFee) || 0,
        incomeAc: b.ParkingIncomeAccount || '',
        prepaidAc: b.ParkingIncomeAccountPP || '',
        percent: 0,
      },
      {
        desc: "OTHERS",
        amount: Number(contract.otherFee) || 0,
        incomeAc: b.EjariIncomeAccount || '',
        prepaidAc: b.EjariIncomeAccountPP || '',
        percent: 0,
      },
    ];
  }, [selectedBuilding, data.contract.rent, data.contract.serviceCharge, data.contract.ejariFee, data.contract.parkingFee, data.contract.otherFee, data.contract.commissionFee]);

  const [incomeBreakupEdits, setIncomeBreakupEdits] = useState({});

  const getIncomeBreakupRow = (index) => {
    const base = incomeBreakupData[index] || {};
    const edits = incomeBreakupEdits[index] || {};
    return { ...base, ...edits };
  };

  const updateIncomeBreakup = (index, field, value) => {
    setIncomeBreakupEdits(prev => ({
      ...prev,
      [index]: { ...(prev[index] || {}), [field]: value }
    }));
  };

  const incomeBreakupTotal = useMemo(() => {
    let totalAmount = 0;
    let totalPercent = 0;
    for (let i = 0; i < 6; i++) {
      const row = getIncomeBreakupRow(i);
      totalAmount += Number(row.amount) || 0;
      totalPercent += Number(row.percent) || 0;
    }
    return { totalAmount, totalPercent };
  }, [incomeBreakupData, incomeBreakupEdits]);


  const totalUnits = useMemo(() => {
    return selectedUnits.filter(u => (u.UnitID || u.unit_id)).length;
  }, [selectedUnits]);

  const totalRent = useMemo(() => {
    // return selectedUnits.reduce((sum, u) => sum + (Number(u.MonthlyRent) || 0), 0);
    return selectedUnits.reduce((sum, u) => sum + (Number(u.AnnualRent) || 0), 0);
  }, [selectedUnits]);

  const totalServiceCharge = useMemo(() => {
    return selectedUnits.reduce((sum, u) => sum + (Number(u.ServiceCharge) || 0), 0);
  }, [selectedUnits]);

  const totalPeriodDays = useMemo(() => {
    const from = new Date(data.contract.periodFrom);
    const to = new Date(data.contract.periodTo);
    if (isNaN(from) || isNaN(to) || to < from) return 0;
    return Math.ceil((to - from) / (1000 * 60 * 60 * 24)) + 1;
  }, [data.contract.periodFrom, data.contract.periodTo]);


  useEffect(() => {
    console.log("totalPeriodDays:", totalPeriodDays)
  }, [totalPeriodDays])

  const unitIdsString = useMemo(() => {
    return selectedUnits
      .map(u => u.UnitID || u.unit_id || '')
      .filter(Boolean)
      .join(', ');
  }, [selectedUnits]);

  useEffect(() => {
    if (selectedUnits.length > 0 && totalPeriodDays > 0) {
      const totalRentPerDay = selectedUnits.reduce((sum, u) => {
        // const monthlyRent = Number(u.MonthlyRent) || 0;
        const monthlyRent = Number(u.AnnualRent) || 0;
        return sum + (monthlyRent / 365);
      }, 0);
      // const calculatedRent = Math.round(totalRentPerDay * totalPeriodDays * 100) / 100;
      const calculatedRent = Number(
        (totalRentPerDay * totalPeriodDays).toFixed(3)
      );
      update('contract', 'rent', calculatedRent);

      const totalSChargePerDay = selectedUnits.reduce((sum, u) => {
        const serviceCharge = Number(u.ServiceCharge) || 0;
        return sum + (serviceCharge / 365);
      }, 0);
      // const calculatedSCharge = Math.round(totalSChargePerDay * totalPeriodDays * 100) / 100;
      const calculatedSCharge = Number(
        (totalSChargePerDay * totalPeriodDays).toFixed(3)
      );
      update('contract', 'serviceCharge', calculatedSCharge);
    }
  }, [selectedUnits, totalPeriodDays]);

  useEffect(() => {
    update('contract', 'selectedUnits', unitIdsString);
  }, [unitIdsString]);


  ///////////////////////////////////////////////////////////

  // Add finance totals state
  const [financeTotals, setFinanceTotals] = useState({
    rent: 0,
    serviceCharge: 0,
    deposit: 0,
    ejariFee: 0,
    ejariVat: 0,
    commissionFee: 0,
    parkingFee: 0,
    discount: 0,
    otherFee: 0,
    preSettled: 0,
    totalRent: 0,
    totalService: 0,
    vatPercent: vatp,
    serviceVatPercent: vatp,
    vatAmt: 0,
    serviceVatAmt: 0,
    commissionVatAmt: 0,
    parkingFeeVat: 0,
    grossTotal: 0,
    netIncome: 0,
    netRent: 0,
    netService: 0,
    netCommission: 0,
    totalAllocation: 0,
    totalUnits: 0
  });

  // Use the calculation hook
  const {
    calculationResults,
    totalUnitsCC,
    totalRentFromUnits,
    totalServiceFromUnits,
    calculate,
    calculateDebit
  } = useContractCalculations(data, selectedUnits, selectedBuilding, dateMetrics);


  useEffect(() => {
    if (data.contract) {
      const totals = calculateFinanceTotals(
        data.contract,
        selectedUnits,
        selectedBuilding,
        dateMetrics
      );
      setFinanceTotals(totals);

      const netIncome = totals.netIncome || 0;
      update('rentAlloc', 'totalIncome', netIncome);
    }
  }, [data.contract, selectedUnits, selectedBuilding, dateMetrics]);


  const handleInputChange = (section, field, value) => {
    update(section, field, value);

    // Recalculate on relevant field changes
    if (['rent', 'serviceCharge', 'deposit', 'ejariFee', 'ejariVat', 'commissionFee',
      'parkingFee', 'discount', 'otherFee', 'preSettled'].includes(field)) {
      // Trigger recalculation
      setTimeout(() => {
        const totals = calculateFinanceTotals(
          { ...data.contract, [field]: value },
          selectedUnits,
          selectedBuilding,
          dateMetrics
        );
        setFinanceTotals(totals);
      }, 100);
    }
  };

  // Function to handle calculation triggers
  const handleCalculate = () => {
    const results = calculate();
    console.log('Calculation results:', results);
  };


  console.log("selectedBuilding:", selectedBuilding)
  console.log("selectedBuilding.PDCAccount:", selectedBuilding.PDCAccount)
  console.log("selectedBuilding.CashAccount:", selectedBuilding.CashAccount)


  ///////////////////////////////////////////////////////////

  return (
    <div className="min-h-screen bg-slate-50/50 p-4 md:p-6 text-slate-800 font-sans">

      {/* Universal Sticky Command Bar Header Context */}
      <div className="mx-auto bg-white rounded-xl border border-slate-200 shadow-xs p-4 mb-6">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
          <div>
            <h1 className="text-xl font-bold text-slate-900 mt-0.5">Tenancy Contract Register</h1>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:flex items-start gap-3 w-full lg:w-auto">

            {/* Contract No */}
            <div className="flex flex-col gap-1">
              <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                Contract No <span className="text-red-500">*</span>
              </label>
              <input
                id="g_contractNo"
                type="text"
                value={data.header.contractNo}
                onChange={(e) => update("header", "contractNo", e.target.value)}
                onBlur={(e) => {
                  const val = e.target.value?.trim();
                  if (val) checkDuplicateContract(val);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    const val = e.target.value?.trim();
                    if (val) checkDuplicateContract(val);
                  }
                }}
                required
                className={`w-[200px] px-3 py-2 text-sm border rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none ${!data.header.contractNo
                  ? "border-red-400 bg-red-50/30"
                  : "border-gray-200"
                  }`}
                placeholder="Enter contract number"
              />
              {!data.header.contractNo && (
                <span className="text-[10px] text-red-500 font-medium">
                  Contract number is required
                </span>
              )}
            </div>

            {/* Date */}
            <div className="flex flex-col gap-1">
              <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                Date
              </label>
              <input
                id="g_date"
                type="date"
                value={data.header.date}
                onChange={(e) => update("header", "date", e.target.value)}
                required
                className={`w-[200px] px-3 py-2 text-sm border rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none ${!data.header.date
                  ? "border-red-400 bg-red-50/30"
                  : "border-gray-200"
                  }`}
              />
              {!data.header.date && (
                <span className="text-[10px] text-red-500 font-medium">
                  Date is required
                </span>
              )}
            </div>

            {/* State */}
            {/* <div className="flex flex-col gap-1">
              <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                State
              </label>
              <select
                id="g_type"
                value={data.header.type}
                onChange={(e) => update("header", "type", e.target.value)}
                className={`w-[200px] px-3 py-2 text-sm border rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none ${!data.header.type
                  ? "border-red-400 bg-red-50/30"
                  : "border-gray-200"
                  }`}
              >
                <option value="">Select State</option>
                <option value="NEW">NEW</option>
                <option value="RENEWAL">RENEWAL</option>
                <option value="MODIFY">MODIFY</option>
              </select>
              {!data.header.type && (
                <span className="text-[10px] text-red-500 font-medium">
                  State is required
                </span>
              )}
            </div> */}

            {/* Approval */}
            <div className="flex flex-col gap-1">
              <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                Approval
              </label>
              <select
                id="g_status"
                value={data.header.status}
                onChange={(e) => update("header", "status", e.target.value)}
                className={`w-[200px] px-3 py-2 text-sm border rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none ${!data.header.status
                  ? "border-red-400 bg-red-50/30"
                  : "border-gray-200"
                  }`}
              >
                <option value="">Select Approval</option>
                <option value="APPROVED">APPROVED</option>
                <option value="FOR APPROVAL">FOR APPROVAL</option>
              </select>
              {!data.header.status && (
                <span className="text-[10px] text-red-500 font-medium">
                  Approval is required
                </span>
              )}
            </div>

          </div>
        </div>
      </div>

      {/* Primary Workspace Nav tabs */}
      <div className="mx-auto mb-6">
        <div className="flex overflow-x-auto bg-slate-200/60 p-1 rounded-xl scrollbar-none">
          {[
            { id: 'contract_info', label: 'Contract Information' },
            { id: 'rent_allocation', label: 'Rent Allocation' },
            { id: 'settlement', label: 'Settlement' },
            { id: 'receipt_details', label: 'Receipt Details' },
            { id: 'other_info', label: 'Other Information' }
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => {
                if (!data.header.contractNo) {
                  alert('Please enter a Contract Number before proceeding.');
                  return;
                }
                setActiveTab(tab.id);
              }}
              className={`flex-nowrap whitespace-nowrap px-4 py-2 text-xs font-semibold rounded-lg transition-all ${activeTab === tab.id ? 'bg-white text-blue-600 shadow-xs' : 'text-slate-600 hover:text-slate-900'}`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Main Workspace Frame */}
      <div className="mx-auto">

        {/* TAB 1: CONTRACT INFORMATION */}
        {activeTab === 'contract_info' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-fadeIn">
            <div className="lg:col-span-1 space-y-6">



              {/* CARD 1: Contract Parameters */}
              <Card title="Contract Information">

                {/* <button
                  type="button"
                  onClick={handleCalculate}
                  className="px-4 py-2 mb-4 bg-blue-600 hover:bg-blue-700 active:scale-95 text-white text-xs font-bold uppercase tracking-wider rounded-lg transition-all"
                >
                  Recalculate
                </button> */}

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-xs font-bold text-slate-400 uppercase tracking-widest mb-1.5">Building ID</label>
                    <div className="relative">
                      <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400">
                        <Building2 className="w-3.5 h-3.5" />
                      </span>
                      <select
                        value={selectedBuildingID}
                        onChange={(e) => setSelectedBuildingID(e.target.value)}
                        className="w-full pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 transition-all cursor-pointer"
                      >
                        {buildings.length === 0 && <option value="">No buildings found</option>}
                        {buildings.map(b => (
                          <option key={b.BuildingID} value={b.BuildingID}>{b.BuildingID} ({b.BuildingName})</option>
                        ))}
                      </select>
                    </div>
                  </div>


                  {/* Unit(s) Multi-line Input Box */}
                  <div>
                    <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">
                      Unit(s)
                    </label>
                    <textarea
                      rows={1}
                      id="selectedUnits"
                      readOnly
                      value={data.contract.selectedUnits || ''}
                      className="cursor-not-allowed w-full text-sm rounded-xl border border-slate-200 bg-slate-50/50 px-3.5 py-2.5 text-slate-700 font-medium focus:outline-none min-h-[44px] resize-none"
                      placeholder="Selected unit IDs"
                    />
                  </div>

                  <Select
                    label="Tenancy Type"
                    id="tenancyType"
                    value={data.contract.tenancyType}
                    options={[{ value: 'RESIDENTIAL', label: 'RESIDENTIAL' }, { value: 'COMMERCIAL', label: 'COMMERCIAL' }, { value: 'VILLA', label: 'VILLA' },
                    { value: 'INDUSTRIAL', label: 'INDUSTRIAL' },
                    { value: 'SHOP', label: 'SHOP' },]}
                    onChange={(e) => update('contract', 'tenancyType', e.target.value)}
                  />

                  {/* Date Range Block */}
                  {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:col-span-2"> */}
                  <div className="flex justify-between items-center gap-4">

                    <Input
                      label="Period From"
                      id="periodFrom"
                      type="date"
                      value={data.contract.periodFrom}
                      onChange={(e) => update("contract", "periodFrom", e.target.value)}
                    />

                    <div className="flex flex-col">
                      <label className="text-xs font-medium text-transparent mb-2">
                        Action
                      </label>

                      <div className="relative">
                        <button
                          type="button"
                          onClick={() => setShowMonthsAccordion(!showMonthsAccordion)}
                          className="h-6 px-5 rounded-lg bg-blue-600 hover:bg-blue-700 active:scale-95
                           text-white text-xs font-semibold transition-all
                           shadow-sm hover:shadow-md whitespace-nowrap flex items-center gap-1"
                        >
                          Months
                          <svg className={`w-3 h-3 transition-transform ${showMonthsAccordion ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </button>

                        {showMonthsAccordion && (
                          <div className="absolute z-50 mt-1 bg-white border border-slate-200 rounded-lg shadow-lg p-2 w-48">
                            <div className="grid grid-cols-4 gap-1">
                              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((months) => (
                                <button
                                  key={months}
                                  type="button"
                                  onClick={() => {
                                    if (!data.contract.periodFrom) return;
                                    const from = new Date(data.contract.periodFrom);
                                    const to = new Date(from);
                                    to.setMonth(to.getMonth() + months);
                                    to.setDate(to.getDate() - 1);
                                    update("contract", "periodTo", to.toISOString().split("T")[0]);
                                    setShowMonthsAccordion(false);
                                  }}
                                  className="h-7 text-[10px] font-semibold rounded bg-slate-100 hover:bg-blue-100 hover:text-blue-700 text-slate-700 transition-colors"
                                >
                                  {months}
                                </button>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <Input
                      label="Period To"
                      id="periodTo"
                      type="date"
                      value={data.contract.periodTo}
                      onChange={(e) => update("contract", "periodTo", e.target.value)}
                    />

                    <Input
                      label="Ending Date"
                      id="endingDate"
                      type="date"
                      value={data.contract.endingDate || data.contract.periodTo}
                      disabled={true}
                      onChange={() => { }}
                    />
                    {/* </div> */}
                  </div>
                </div>

                {/* Date metrics block (Years, Months, Days) */}
                <div className="grid grid-cols-3 gap-2 mt-4 p-3 bg-slate-50 border border-slate-200/60 rounded-lg text-center">
                  <div><span className="block text-sm font-bold text-slate-800">{dateMetrics.years}</span><span className="text-[10px] uppercase font-medium text-slate-400">Years</span></div>
                  <div><span className="block text-sm font-bold text-slate-800">{dateMetrics.months}</span><span className="text-[10px] uppercase font-medium text-slate-400">Months</span></div>
                  <div><span className="block text-sm font-bold text-slate-800">{dateMetrics.days}</span><span className="text-[10px] uppercase font-medium text-slate-400">Days</span></div>
                </div>

                <div className="grid grid-cols-3 gap-4 mt-4">
                  <Input label="Subject" id="subject" value={data.contract.subject} onChange={(e) => update('contract', 'subject', e.target.value)} />
                  <Input label="Terms" id="terms" value={data.contract.terms} onChange={(e) => update('contract', 'terms', e.target.value)} />
                  <Input label="Mode of Pay" id="modeOfPay" value={data.contract.modeOfPay} onChange={(e) => update('contract', 'modeOfPay', e.target.value)} />
                </div>
              </Card>



              {/* CARD 3: Units Table */}
              <Card title={
                <div className="flex items-center gap-2">
                  <span>Units</span>
                  <span className="px-2 py-0.5 text-[10px] font-bold bg-blue-100 text-blue-700 rounded-full">{totalUnits}</span>
                  {totalRent > 0 && (
                    <span className="px-2 py-0.5 text-[10px] font-bold bg-emerald-100 text-emerald-700 rounded-full">Total Rent: {totalRent.toLocaleString()} {currencyFromLocal}</span>
                  )}
                  {totalServiceCharge > 0 && (
                    <span className="px-2 py-0.5 text-[10px] font-bold bg-emerald-100 text-emerald-700 rounded-full">Total S.Charge: {totalServiceCharge.toLocaleString()} {currencyFromLocal}</span>
                  )}
                </div>
              }>
                <div className="min-h-[370px] overflow-x-auto border border-slate-200 rounded-lg">
                  <table className="w-full text-left border-collapse text-xs">
                    <thead>
                      <tr className="bg-slate-50 border-b border-slate-200 text-slate-500 font-semibold uppercase tracking-wider">
                        <th className="p-3">Unit ID</th>
                        <th className="p-3">Unit No</th>
                        <th className="p-3">Unit Name</th>
                        <th className="p-3">Rent/Year</th>
                        <th className="p-3">Rent/Day</th>
                        <th className="p-3">S.Charge/Year</th>
                        <th className="p-3">S.Charge/Day</th>
                        <th className="p-3">Type</th>
                        <th className="p-3">Status</th>
                        <th className="p-3">Parking Count</th>
                        <th className="p-3">Parking No</th>
                        <th className="p-3 text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 text-slate-700">
                      {selectedUnits.length === 0 ? (
                        <tr>
                          <td colSpan={10} className="py-12 text-center text-sm text-slate-400 font-medium">
                            No units selected. Click "Add" to select units.
                          </td>
                        </tr>
                      ) : (
                        selectedUnits.map((unit, idx) => (
                          <tr
                            key={unit.UnitID || unit.unit_id || idx}
                            onClick={() => setSelectedUnitForSplit(unit)}
                            className={`hover:bg-slate-50/60 transition-colors cursor-pointer ${selectedUnitForSplit && (selectedUnitForSplit.UnitID || selectedUnitForSplit.unit_id) === (unit.UnitID || unit.unit_id)
                              ? 'bg-blue-50 border-l-2 border-l-blue-500'
                              : ''
                              }`}
                          >
                            <td className="p-3  font-medium text-slate-900">{unit.UnitID || unit.unit_id || '-'}</td>
                            <td className="p-3 text-center">{unit.UnitNo || '-'}</td>
                            <td className="p-3 text-center">{unit.UnitName || '-'}</td>

                            <td className="p-3 text-center">
                              <input
                                type="number"
                                // value={unit.MonthlyRent || ''}
                                value={unit.AnnualRent || ''}
                                // onChange={(e) => handleUnitFieldChange(unit.UnitID || unit.unit_id, 'MonthlyRent', e.target.value)}
                                onChange={(e) => handleUnitFieldChange(unit.UnitID || unit.unit_id, 'AnnualRent', e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                                className="w-20 text-right text-xs rounded-lg border border-slate-200 bg-white p-1.5 text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500/10"
                              />
                            </td>
                            {/* <td className="p-3 text-center">{totalPeriodDays > 0 ? (Number(unit.MonthlyRent || 0) / 365).toLocaleString(undefined, { minimumFractionDigits: 10, maximumFractionDigits: 10 }) : '-'}</td> */}
                            <td className="p-3 text-center">{totalPeriodDays > 0 ? (Number(unit.AnnualRent || 0) / 365).toLocaleString(undefined, { minimumFractionDigits: 10, maximumFractionDigits: 10 }) : '-'}</td>
                            <td className="p-3 text-center">
                              <input
                                type="number"
                                value={unit.ServiceCharge || ''}
                                onChange={(e) => handleUnitFieldChange(unit.UnitID || unit.unit_id, 'ServiceCharge', e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                                className="w-20 text-right text-xs rounded-lg border border-slate-200 bg-white p-1.5 text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500/10"
                              />
                            </td>
                            <td className="p-3 text-center">{totalPeriodDays > 0 ? (Number(unit.ServiceCharge || 0) / 365).toLocaleString(undefined, { minimumFractionDigits: 10, maximumFractionDigits: 10 }) : '-'}</td>
                            <td className="p-3 text-center">{unit.UnitType || '-'}</td>
                            <td className="p-3 text-center">{unit.UnitStatus || '-'}</td>
                            <td className="p-3 text-center">{unit.ParkingCount || '-'}</td>
                            <td className="p-3 text-center">{unit.ParkingCount || '-'}</td>
                            <td className="p-3 text-center">
                              <button
                                type="button"
                                onClick={() => handleRemoveUnit(unit.UnitID || unit.unit_id)}
                                className="p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-md transition-colors"
                                title="Remove unit"
                              >
                                <Trash2 size={13} />
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Sub-table Add/Split Controls */}
                <div className="mt-4 p-4 bg-slate-50 border border-slate-200 rounded-xl">
                  {!showSplitPanel ? (
                    <div className="flex gap-2 items-end">
                      {/* <Tooltip title={!selectedUnitForSplit ? "Select a unit row first, then click Split" : ""} arrow>
                        <span>
                          <button
                            type="button"
                            onClick={() => setShowSplitPanel(true)}
                            disabled={!selectedUnitForSplit}
                            className={`h-11 px-6 text-xs font-bold uppercase tracking-wider rounded-lg transition-all ${selectedUnitForSplit
                              ? "bg-blue-500 hover:bg-blue-600 active:scale-95 text-white"
                              : "bg-slate-100 text-slate-400 cursor-not-allowed"
                              }`}
                          >
                            Split
                          </button>
                        </span>
                      </Tooltip> */}
                      <div className="flex-1" />
                      <Tooltip title={!hasUnits ? "Selected building has no units" : ""} arrow>
                        <span>
                          <button
                            type="button"
                            onClick={handleOpenUnitModal}
                            disabled={!hasUnits}
                            className={`h-11 px-6 text-xs font-bold uppercase tracking-wider rounded-lg transition-all ${hasUnits
                              ? "bg-emerald-600 hover:bg-emerald-700 active:scale-95 text-white"
                              : "bg-slate-300 text-slate-500 cursor-not-allowed"
                              }`}
                          >
                            Add Unit
                          </button>
                        </span>
                      </Tooltip>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-xs font-bold text-slate-600 uppercase">
                          Split for: {selectedUnitForSplit?.UnitNo || selectedUnitForSplit?.UnitID || ''}
                        </span>
                        <button
                          type="button"
                          onClick={() => { setShowSplitPanel(false); update('contract', 'subRent', ''); update('contract', 'subSCharge', ''); }}
                          className="text-xs text-slate-400 hover:text-red-500 transition-colors"
                        >
                          Close
                        </button>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
                        <Input
                          label="Rent"
                          id="subRent"
                          placeholder="0.00"
                          value={data.contract.subRent || ""}
                          onChange={(e) => update("contract", "subRent", e.target.value)}
                        />
                        <button
                          type="button"
                          onClick={handleSplitRent}
                          className="w-full h-11 text-xs font-bold uppercase tracking-wider rounded-lg bg-blue-500 hover:bg-blue-600 active:scale-95 text-white transition-all"
                        >
                          Split Rent
                        </button>
                        <Input
                          label="S.Charge"
                          id="subSCharge"
                          placeholder="0.00"
                          value={data.contract.subSCharge || ""}
                          onChange={(e) => update("contract", "subSCharge", e.target.value)}
                        />
                        <button
                          type="button"
                          onClick={handleSplitSCharge}
                          className="w-full h-11 text-xs font-bold uppercase tracking-wider rounded-lg bg-violet-500 hover:bg-violet-600 active:scale-95 text-white transition-all"
                        >
                          Split S.Charge
                        </button>
                        <div />
                      </div>
                    </div>
                  )}
                </div>
              </Card>


            </div>

            {/* Right Sidebar Columns */}


            <div className="space-y-6">

              {/* CARD 2: Tenant Parameters */}
              <Card title="Tenant Profile">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="md:col-span-2">
                    {/* <Input label="Tenant" id="tenantName" value={data.contract.tenantName} onChange={(e) => update('contract', 'tenantName', e.target.value)} /> */}
                    <Tooltip title={data.contract.tenantName ? "" : "Press F2 to select tenant"} arrow>
                      <div className="flex flex-col items-left gap-1.5">
                        <label className="block text-[10px]  text-slate-400 uppercase tracking-wider whitespace-nowrap">
                          Tenant
                        </label>

                        <input
                          id="tenantName"
                          value={data.contract.tenantName || ""}
                          readOnly
                          placeholder="Press F2"
                          onKeyDown={(e) => {
                            if (e.key === "F2") {
                              e.preventDefault();
                              setActiveModalField("tenantName");
                              fetchAccountList("CUSTOMERS");
                              setTenantModalOpen(true);
                            }
                          }}
                          className="w-full px-3 py-2 text-sm border border-gray-200 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none cursor-pointer"
                        />
                        {data.contract.tenantName && (
                          <button
                            type="button"
                            onClick={clearTenantField}
                            className="shrink-0 p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-md transition-colors"
                            title="Remove tenant"
                          >
                            <Trash2 size={13} />
                          </button>
                        )}
                      </div>
                    </Tooltip>
                  </div>

                  <Input label="Account" id="tenantAccount" value={data.contract.tenantAccount} onChange={(e) => update('contract', 'tenantAccount', e.target.value)} />
                  <div className="md:col-span-4">
                    <Input label="TRN" id="tenantTRN" value={data.contract.tenantTRN} onChange={(e) => update('contract', 'tenantTRN', e.target.value)} />
                  </div>

                </div>
              </Card>
              {/* <Card title="Income Breakup" className="bg-slate-900 text-white border-none shadow-md">

                <div className="overflow-x-auto border border-slate-200 rounded-xl">
                  <table className="w-full text-left border-collapse text-xs">
                    <thead>
                      <tr className="bg-slate-50 border-b border-slate-200 text-slate-500 font-semibold uppercase tracking-wider">
                        <th className="p-3.5">Description</th>
                        <th className="p-3.5 ">Amount</th>
                        <th className="p-3.5">Income A/C</th>
                        <th className="p-3.5">Prepaid A/C</th>
                        <th className="p-3.5 text-right">%</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 text-slate-700">
                      {incomeBreakupData.map((_, index) => {
                        const row = getIncomeBreakupRow(index);
                        const isEditable = (row.desc === 'SERVICE' || row.desc === 'COMMISSION');
                        return (
                          <tr key={index} className="hover:bg-slate-50/60 transition-colors">
                            <td className="p-3.5 font-medium text-slate-900">{row.desc}</td>
                            <td className="p-0.5 text-center">
                              {isEditable ? (
                                <input
                                  type="number"
                                  value={row.amount || ''}
                                  onChange={(e) => {
                                    const val = Number(e.target.value) || 0;
                                    updateIncomeBreakup(index, 'amount', val);
                                    if (row.desc === 'SERVICE') {
                                      update('contract', 'serviceCharge', val);
                                    } else if (row.desc === 'COMMISSION') {
                                      update('contract', 'commissionFee', val);
                                    }
                                  }}
                                  className="w-[60px] text-right text-xs rounded-lg border border-slate-200 bg-white p-1.5 text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500/10"
                                />
                              ) : (
                                <span className="text-center">{row.amount || '-'}</span>
                              )}
                            </td>
                            <td className=" text-center  p-3.5">{row.incomeAc || '-'}</td>
                            <td className="  text-center  p-3.5">{row.prepaidAc || '-'}</td>
                            <td className=" text-center  p-3.5">{row.percent || '-'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr className="bg-slate-100/60 font-semibold border-t-2 border-slate-300">
                        <td className="p-3.5 text-slate-800 font-bold">Total</td>
                        <td className="p-3.5 text-right text-slate-900 font-bold">
                          {incomeBreakupTotal.totalAmount.toLocaleString(undefined, { minimumFractionDigits: 3 })}
                        </td>
                        <td className="p-3.5"></td>
                        <td className="p-3.5"></td>
                        <td className="p-3.5 text-right text-slate-900 font-bold">
                          {incomeBreakupTotal.totalPercent}%
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </Card> */}


              <Card title="Rent Info" className="bg-slate-900  text-gray-600  border-none shadow-lg">
                <div className="space-y-5 text-xs">

                  {/* Top Row: 3-Column Grid */}
                  <div className="grid grid-cols-3 gap-0 divide-x divide-slate-700/60">

                    {/* Column 1: Rent */}
                    <div className="space-y-3 pr-4">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-blue-400"></span>
                        <span className="text-[10px] font-bold uppercase tracking-wider text-blue-400">Rent</span>
                      </div>
                      <div className="flex flex-col">
                        <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Rent Amount</label>
                        <input
                          type="number"
                          value={data.contract.rent || ''}
                          readOnly
                          className="w-full bg-gray-100 border border-gray-300 rounded-lg text-right font-semibold text-gray-600 py-2 px-3 text-sm focus:outline-none cursor-not-allowed"
                          placeholder="0.00"
                        />
                        <div className="flex flex-wrap gap-1 mt-1.5">
                          {selectedBuilding.RentalIncomeAccount && <span className="px-2 py-0.5 text-[9px] font-medium bg-blue-500/15 text-blue-400 border border-blue-500/20 rounded-md">INC: {selectedBuilding.RentalIncomeAccount}</span>}
                          {selectedBuilding.RentalIncomeAccountPP && <span className="px-2 py-0.5 text-[9px] font-medium bg-violet-500/15 text-violet-400 border border-violet-500/20 rounded-md">PP: {selectedBuilding.RentalIncomeAccountPP}</span>}
                        </div>
                      </div>
                      <div className="flex items-center justify-between pt-1">
                        {/* <span className="text-slate-500">Rent VAT ({financeTotals.vatPercent}%): </span> */}
                        <span className="text-slate-500">Rent VAT ({financeTotals.vatPercent}%): </span>
                        <span className="font-semibold text-slate-700">{Number(financeTotals.vatAmt || 0).toLocaleString()} {currencyFromLocal}</span>
                      </div>
                      <div className="flex items-center justify-between py-1.5 px-2 bg-emerald-500/10 rounded-lg border border-emerald-500/20">
                        <span className="text-emerald-600 font-medium">Net Rent</span>
                        <span className="font-bold text-emerald-600 text-sm">{Number(financeTotals.netRent || 0).toLocaleString()} {currencyFromLocal}</span>
                      </div>
                    </div>

                    {/* Column 2: Deposit & Fees */}
                    <div className="space-y-3 px-4">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-amber-400"></span>
                        <span className="text-[10px] font-bold uppercase tracking-wider text-amber-400">Deposit & Fees</span>
                      </div>
                      <div className="flex flex-col">
                        <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Deposit</label>
                        <input
                          type="number"
                          value={data.contract.deposit || ''}
                          onChange={(e) => update('contract', 'deposit', e.target.value)}
                          className="w-full bg-gray-100 border border-gray-300 rounded-lg text-right font-semibold  text-gray-600  py-2 px-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500/40 focus:border-blue-500/40 transition-all placeholder-slate-600"
                          placeholder="0.00"
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Ejari Fee</label>
                        <input
                          type="number"
                          value={data.contract.ejariFee || ''}
                          onChange={(e) => update('contract', 'ejariFee', e.target.value)}
                          className="w-full bg-gray-100 border border-gray-300 rounded-lg text-right font-semibold  text-gray-600  py-2 px-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500/40 focus:border-blue-500/40 transition-all placeholder-slate-600"
                          placeholder="0.00"
                        />
                        <div className="flex flex-wrap gap-1 mt-1.5">
                          {selectedBuilding.EjariIncomeAccount && <span className="px-2 py-0.5 text-[9px] font-medium bg-blue-500/15 text-blue-400 border border-blue-500/20 rounded-md">INC: {selectedBuilding.EjariIncomeAccount}</span>}
                          {selectedBuilding.EjariIncomeAccountPP && <span className="px-2 py-0.5 text-[9px] font-medium bg-violet-500/15 text-violet-400 border border-violet-500/20 rounded-md">PP: {selectedBuilding.EjariIncomeAccountPP}</span>}
                        </div>
                      </div>
                      <div className="flex flex-col">
                        <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Other Fee</label>
                        <input
                          type="number"
                          value={data.contract.otherFee || ''}
                          onChange={(e) => update('contract', 'otherFee', e.target.value)}
                          className="w-full bg-gray-100 border border-gray-300 rounded-lg text-right font-semibold  text-gray-600  py-2 px-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500/40 focus:border-blue-500/40 transition-all placeholder-slate-600"
                          placeholder="0.00"
                        />
                        <div className="flex flex-wrap gap-1 mt-1.5">
                          {selectedBuilding.EjariIncomeAccount && <span className="px-2 py-0.5 text-[9px] font-medium bg-blue-500/15 text-blue-400 border border-blue-500/20 rounded-md">INC: {selectedBuilding.EjariIncomeAccount}</span>}
                          {selectedBuilding.EjariIncomeAccountPP && <span className="px-2 py-0.5 text-[9px] font-medium bg-violet-500/15 text-violet-400 border border-violet-500/20 rounded-md">PP: {selectedBuilding.EjariIncomeAccountPP}</span>}
                        </div>
                      </div>
                    </div>

                    {/* Column 3: Service Charge, Discount & Parking */}
                    <div className="space-y-3 pl-4">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-cyan-400"></span>
                        <span className="text-[10px] font-bold uppercase tracking-wider text-cyan-400">Service & Extras</span>
                      </div>
                      <div className="flex flex-col">
                        <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Service Charge</label>
                        <input
                          type="number"
                          value={data.contract.serviceCharge || ''}
                          readOnly
                          className="w-full bg-gray-100 border border-gray-300 rounded-lg text-right font-semibold text-gray-600 py-2 px-3 text-sm focus:outline-none cursor-not-allowed"
                          placeholder="0.00"
                        />
                        <div className="flex flex-wrap gap-1 mt-1.5">
                          {selectedBuilding.MaintenanceIncomeAccount && <span className="px-2 py-0.5 text-[9px] font-medium bg-blue-500/15 text-blue-400 border border-blue-500/20 rounded-md">INC: {selectedBuilding.MaintenanceIncomeAccount}</span>}
                          {selectedBuilding.MaintenanceIncomeAccountPP && <span className="px-2 py-0.5 text-[9px] font-medium bg-violet-500/15 text-violet-400 border border-violet-500/20 rounded-md">PP: {selectedBuilding.MaintenanceIncomeAccountPP}</span>}
                        </div>
                      </div>
                      <div className="flex items-center justify-between pt-1">
                        <span className="text-slate-500">S.C. VAT ({financeTotals.serviceVatPercent}%): </span>
                        <span className="font-semibold text-slate-700">{Number(financeTotals.serviceVatAmt || 0).toLocaleString()} {currencyFromLocal}</span>
                      </div>
                      <div className="flex flex-col">
                        <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Discount</label>
                        <input
                          type="number"
                          value={data.contract.discount || ''}
                          onChange={(e) => update('contract', 'discount', e.target.value)}
                          className="w-full bg-gray-100 border border-gray-300 rounded-lg text-right font-semibold text-rose-400 py-2 px-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-500/40 focus:border-rose-500/40 transition-all placeholder-slate-600"
                          placeholder="0.00"
                        />
                      </div>
                    </div>

                  </div>

                  {/* Divider */}
                  <div className="border-t border-gray-300"></div>

                  {/* Bottom Row: Fees, Totals & Net Income */}
                  <div className="grid grid-cols-4 gap-3">

                    {/* Parking */}
                    <div className="flex flex-col">
                      <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Parking Fee</label>
                      <input
                        type="number"
                        value={data.contract.parkingFee || ''}
                        onChange={(e) => update('contract', 'parkingFee', e.target.value)}
                        className="w-full bg-gray-100 border border-gray-300 rounded-lg text-right font-semibold text-gray-600 py-2 px-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500/40 focus:border-blue-500/40 transition-all placeholder-slate-600"
                        placeholder="0.00"
                      />
                      <div className="flex flex-wrap gap-1 mt-1.5">
                        {selectedBuilding.ParkingIncomeAccount && <span className="px-2 py-0.5 text-[9px] font-medium bg-blue-500/15 text-blue-400 border border-blue-500/20 rounded-md">INC: {selectedBuilding.ParkingIncomeAccount}</span>}
                        {selectedBuilding.ParkingIncomeAccountPP && <span className="px-2 py-0.5 text-[9px] font-medium bg-violet-500/15 text-violet-400 border border-violet-500/20 rounded-md">PP: {selectedBuilding.ParkingIncomeAccountPP}</span>}
                      </div>
                    </div>

                    {/* Parking VAT */}
                    <div className="flex flex-col">
                      <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Parking. VAT ({financeTotals.vatPercent}%)</label>
                      <div className="w-full bg-gray-200 border border-gray-300 rounded-lg text-right font-semibold text-gray-600 py-2 px-3 text-sm">
                        {Number(financeTotals.parkingFeeVat || 0).toLocaleString()} {currencyFromLocal}
                      </div>
                    </div>

                    {/* Commission */}
                    <div className="flex flex-col">
                      <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Commission</label>
                      <input
                        type="number"
                        value={data.contract.commissionFee || ''}
                        onChange={(e) => update('contract', 'commissionFee', e.target.value)}
                        className="w-full bg-gray-100 border border-gray-300 rounded-lg text-right font-semibold text-gray-600 py-2 px-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500/40 focus:border-blue-500/40 transition-all placeholder-slate-600"
                        placeholder="0.00"
                      />
                      <div className="flex flex-wrap gap-1 mt-1.5">
                        {selectedBuilding.CommissionIncomeAccount && <span className="px-2 py-0.5 text-[9px] font-medium bg-blue-500/15 text-blue-400 border border-blue-500/20 rounded-md">INC: {selectedBuilding.CommissionIncomeAccount}</span>}
                        {selectedBuilding.CommissionIncomeAccountPP && <span className="px-2 py-0.5 text-[9px] font-medium bg-violet-500/15 text-violet-400 border border-violet-500/20 rounded-md">PP: {selectedBuilding.CommissionIncomeAccountPP}</span>}
                      </div>
                    </div>

                    {/* Commission VAT */}
                    <div className="flex flex-col">
                      <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Comm. VAT ({financeTotals.vatPercent}%)</label>
                      <div className="w-full bg-gray-200 border border-gray-300 rounded-lg text-right font-semibold text-gray-600 py-2 px-3 text-sm">
                        {Number(financeTotals.commissionVatAmt || 0).toLocaleString()} {currencyFromLocal}
                      </div>
                    </div>

                    {/* Gross Total */}
                    <div className="flex flex-col">
                      <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Gross Total</label>
                      <div className="w-full bg-gray-200 border border-gray-300 rounded-lg text-right font-semibold text-gray-600 py-2 px-3 text-sm">
                        {Number(financeTotals.grossTotal || 0).toLocaleString()} {currencyFromLocal}
                      </div>
                    </div>

                    {/* Pre-Settled */}
                    <div className="flex flex-col">
                      <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Pre-Settled</label>
                      <input
                        type="number"
                        value={data.contract.preSettled || ''}
                        onChange={(e) => update('contract', 'preSettled', e.target.value)}
                        className="w-full bg-gray-100 border border-gray-300 rounded-lg text-right font-semibold text-amber-400 py-2 px-3 text-sm focus:outline-none focus:ring-1 focus:ring-amber-500/40 focus:border-amber-500/40 transition-all placeholder-slate-600"
                        placeholder="0.00"
                      />
                    </div>

                    {/* Net Income - Highlighted */}
                    <div className="flex flex-col col-span-2">
                      <label className="text-slate-500 text-[10px] uppercase tracking-wider mb-1">Net Income</label>
                      <div className="w-full bg-blue-500/10 border border-blue-500/30 rounded-lg text-right font-bold text-blue-400 py-2 px-3 text-lg">
                        {Number(financeTotals.netIncome || 0).toLocaleString()} {currencyFromLocal}
                      </div>
                    </div>

                  </div>

                </div>
              </Card>

              <Card title="Observations">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
                    <Input
                      key={num}
                      label={`Observation ${num}`}
                      id={`observation${num}`}
                      value={data.contract[`observation${num}`] || ''}
                      onChange={(e) => update('contract', `observation${num}`, e.target.value)}
                    />
                  ))}
                </div>
              </Card>

            </div>
          </div>
        )}

        {/* TAB 2: RENT ALLOCATION */}
        {activeTab === 'rent_allocation' && (
          <div className="space-y-4 animate-fadeIn">
            <Card>
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
                <div className="flex justify-between items-center">
                  <h3 className="text-base font-semibold text-slate-800 w-[400px]">Rent Allocation</h3>
                  <Input label="Invoice Number" id="invoiceNumber" value={data.rentAlloc.invoiceNumber} onChange={(e) => update('rentAlloc', 'invoiceNumber', e.target.value)} />
                  {/* <Input label="Invoice Number" id="invoiceNumber" value={rentAlloInvoiceNo} onChange={(e) => update('rentAlloc', 'invoiceNumber', e.target.value)} /> */}
                </div>
                <div className="flex items-center gap-2">
                  <Tooltip title={data.header.status !== "APPROVED" ? "Approval should be approved" : ""} arrow placement="top">
                    <span>
                      <button
                        type="button"
                        disabled={data.header.status !== "APPROVED"}
                        onClick={() => {
                          if (!data.rentAlloc.totalIncome || Number(data.rentAlloc.totalIncome) === 0) {
                            update('rentAlloc', 'totalIncome', financeTotals.netIncome || 0);
                          }
                        }}
                        className={`px-4 py-2 font-medium text-sm rounded-lg transition-all shadow-xs mt-6 ${
                          data.header.status !== "APPROVED"
                            ? "bg-slate-300 text-slate-500 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700 text-white"
                        }`}
                      >
                        Generate
                      </button>
                    </span>
                  </Tooltip>
                  <Input label="Total Income" id="totalIncome" type="number" value={data.rentAlloc.totalIncome} onChange={(e) => update('rentAlloc', 'totalIncome', e.target.value)} />
                </div>
              </div>

              <div className="overflow-x-auto border border-slate-200 rounded-xl">
                <table className="w-full text-left border-collapse text-xs">
                  <thead>
                    <tr className="bg-slate-50 border-b border-slate-200 text-slate-500 font-semibold uppercase tracking-wider">
                      <th className="p-3.5">PDate</th>
                      <th className="p-3.5">Description</th>
                      <th className="p-3.5 text-right">Amount</th>
                      <th className="p-3.5 text-right">Voucher No</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 text-slate-700 font-mono">
                    {rentAllocRows.map((row, index) => (
                      <tr key={index} className="hover:bg-slate-50/60 transition-colors">
                        <td className="p-3.5">{row.pdate}</td>
                        <td className="p-3.5 text-slate-600 font-sans">{row.desc}</td>
                        <td className="p-3.5 text-right text-slate-900">{row.amount.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                        <td className="p-3.5 text-right"><span className="bg-slate-100 text-slate-600 px-2 py-0.5 rounded font-sans text-[11px] font-medium">{row.voucherNo}</span></td>
                      </tr>
                    ))}
                    <tr className="bg-slate-100/60 font-semibold">
                      <td className="p-3.5"></td>
                      <td className="p-3.5 font-sans">
                        <input
                          type="text"
                          value={rentAllocationDesc}
                          onChange={(e) => setRentAllocationDesc(e.target.value)}
                          placeholder="Description"
                          className="w-full text-xs rounded-lg border border-slate-200 bg-white p-1.5 text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500/10"
                        />
                      </td>
                      <td className="p-3.5 text-right text-slate-900">
                        {rentAllocRows.reduce((sum, row) => sum + (Number(row.amount) || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 3 })}
                      </td>
                      <td className="p-3.5"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>
          </div>
        )}

        {/* TAB 3: SETTLEMENT WORKSPACES */}
        {activeTab === 'settlement' && (
          <div className="grid grid-cols-1 gap-6 animate-fadeIn">
            <div className="lg:col-span-2 space-y-4">
              <Card title="Settlement Entries">
                <div className="grid grid-cols-3 gap-4">
                  <div className="flex flex-col items-center gap-4">
                    <div className="flex justify-center items-center gap-4 w-full">
                      <Input label="Settlement Date" type="date" value={data.settlement.settlementDate} onChange={(e) => update('settlement', 'settlementDate', e.target.value)} />
                      <Input label="Vacating Date" type="date" value={data.settlement.vacatingDate} onChange={(e) => update('settlement', 'vacatingDate', e.target.value)} />
                    </div>
                    <Input label="Total" type="number" value={data.settlement.total} onChange={(e) => update('settlement', 'total', e.target.value)} />
                    <Input label="Rent" type="number" value={data.settlement.rent} onChange={(e) => update('settlement', 'rent', e.target.value)} />
                    <Input label="Gross Period" value={data.settlement.grossPeriod} onChange={(e) => update('settlement', 'grossPeriod', e.target.value)} />
                  </div>

                  <div className="mt-4 overflow-x-auto border border-slate-200 rounded-xl">
                    <table className="w-full text-left border-collapse text-xs">
                      <thead>
                        <tr className="bg-slate-50 border-b border-slate-200 text-slate-500 font-semibold uppercase tracking-wider">
                          <th className="p-3.5">Extra Charges Description</th>
                          <th className="p-3.5 text-right">Amount</th>
                          <th className="p-3.5">Statement Reference</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100 text-slate-700">
                        {[
                          { key: 'cancellationFee', refKey: 'cancellationRef', label: 'Cancellation Fee' },
                          { key: 'repairingCharge', refKey: 'repairingRef', label: 'Repairing & Maintenance' },
                          { key: 'electricityWaterDue', refKey: 'elecWaterRef', label: 'Electricity & Water' },
                          { key: 'otherCharges', refKey: 'otherRef', label: 'Other Charges' }
                        ].map(({ key, refKey, label }) => (
                          <tr key={key} className="hover:bg-slate-50/60 transition-colors">
                            <td className="p-3.5 font-medium text-slate-900">{label}</td>
                            <td className="p-3.5 text-right">
                              <input type="number" value={data.settlement[key]} onChange={(e) => update('settlement', key, e.target.value)} className="w-32 text-right text-xs rounded-lg border border-slate-200 bg-white p-1.5 text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500/10" />
                            </td>
                            <td className="p-3.5">
                              <input type="text" value={data.settlement[refKey]} onChange={(e) => update('settlement', refKey, e.target.value)} className="w-full text-xs rounded-lg border border-slate-200 bg-white p-1.5 text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500/10" placeholder="Ref" />
                            </td>
                          </tr>
                        ))}
                        <tr className="bg-slate-100/60 font-semibold">
                          <td className="p-3.5 text-slate-800">Total Charges</td>
                          <td className="p-3.5 text-right text-slate-900">
                            {(Number(data.settlement.cancellationFee) + Number(data.settlement.repairingCharge) + Number(data.settlement.electricityWaterDue) + Number(data.settlement.otherCharges)).toFixed(3)}
                          </td>
                          <td className="p-3.5 text-slate-400"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="flex flex-col items-center gap-3 my-8">
                    <Input label="Settle" id="settle" value={data.settlement.settle} onChange={(e) => update('settlement', 'settle', e.target.value)} />
                    <Input label="A/C" id="account" value={data.settlement.account} onChange={(e) => update('settlement', 'account', e.target.value)} />
                    <Input label="Balance" id="balance" value={data.settlement.balance} onChange={(e) => update('settlement', 'balance', e.target.value)} />
                  </div>
                </div>

                <div className="flex flex-wrap items-center gap-3 mt-8 mb-4">
                  <button type="button" className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold rounded-lg transition-all shadow-xs">Payment Voucher</button>
                  <button type="button" className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold rounded-lg transition-all shadow-xs">Receipt Voucher</button>
                  <button type="button" className="px-4 py-2 bg-slate-700 hover:bg-slate-800 text-white text-xs font-semibold rounded-lg transition-all shadow-xs">Settlement Print</button>
                </div>

                <div className="overflow-x-auto border border-slate-200 rounded-xl">
                  <table className="w-full text-left border-collapse text-xs">
                    <thead>
                      <tr className="bg-slate-50 border-b border-slate-200 text-slate-500 font-semibold uppercase tracking-wider">
                        <th className="p-3.5">Sl No</th>
                        <th className="p-3.5">PV_NUM</th>
                        <th className="p-3.5">Date</th>
                        <th className="p-3.5">Description</th>
                        <th className="p-3.5 text-right">Amount</th>
                        <th className="p-3.5">Chq No</th>
                        <th className="p-3.5">Chq Date</th>
                        <th className="p-3.5">Bank</th>
                        <th className="p-3.5">Type</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 text-slate-700 font-mono">
                      {data.settlement.ledger.map((row, index) => (
                        <tr key={index} className="hover:bg-slate-50/60 transition-colors">
                          <td className="p-3.5 font-sans text-slate-400">{row.slno}</td>
                          <td className="p-3.5 text-blue-600 font-sans font-medium">{row.pvNum}</td>
                          <td className="p-3.5">{row.date}</td>
                          <td className="p-3.5 text-slate-600 font-sans">{row.desc}</td>
                          <td className="p-3.5 text-right font-semibold text-slate-900">{row.amount.toLocaleString()}</td>
                          <td className="p-3.5 font-semibold text-slate-800">{row.chqNo || '—'}</td>
                          <td className="p-3.5 text-amber-600">{row.chqDate || '—'}</td>
                          <td className="p-3.5"><span className="bg-slate-100 px-1.5 py-0.5 rounded text-slate-600">{row.bank}</span></td>
                          <td className="p-3.5"><span className="bg-slate-100 text-slate-600 px-2 py-0.5 rounded font-sans text-[11px] font-medium">{row.type}</span></td>
                        </tr>
                      ))}
                      {data.settlement.ledger.length === 0 && (
                        <tr>
                          <td colSpan={9} className="text-center py-6 text-xs text-slate-400 font-medium font-sans">
                            No previous historical transaction vouchers are logged against this execution lifecycle frame.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Card>
            </div>
          </div>
        )}

        {/* TAB 4: RECEIPT DETAILS */}
        {activeTab === 'receipt_details' && (
          <div className="space-y-2 animate-fadeIn">
            <Card title="Receipts">
              <div className="flex flex-wrap items-center gap-2 ">
                {/* <div className="flex gap-2 items-center justify-center">
                  <Input label="Date" type="date" value={data.receipts.date} onChange={(e) => update('receipts', 'date', e.target.value)} />
                  <Input label="VR No" value={data.receipts.vrNo} onChange={(e) => update('receipts', 'vrNo', e.target.value)} />
                </div> */}
                <div className='flex justify-center items-center gap-4'>
                  <Tooltip title={!data.contract.tenantAccount ? "Select tenancy to create receipt" : Number(data.contract.rent) <= 0 ? "Enter rent amount in contract information" : ""} arrow>
                    <span>
                      {/* <button type="button" onClick={() => navigate('/newReceipt', { state: { contractNo: data.header.contractNo, tenantCode: data.contract.tenantAccount, tenantName: data.contract.tenantName, fromTab: 'receipt_details', tenantAmount: Number(data.contract.tenantAmount) || 0, rent: Number(data.contract.rent) || 0, periodFrom: data.contract.periodFrom || '', periodTo: data.contract.periodTo || '', pdcAccount: selectedBuilding?.PDCAccount || '' } })} disabled={!data.contract.tenantAccount || Number(data.contract.rent) <= 0} className={`px-4 py-2 text-sm mt-6 font-semibold rounded-lg transition-all shadow-xs ${data.contract.tenantAccount && Number(data.contract.rent) > 0 ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-slate-200 text-slate-400 cursor-not-allowed'}`}>New Receipt</button> */}
                      <button type="button" onClick={() => navigate('/newReceipt', { state: { contractNo: data.header.contractNo, tenantCode: data.contract.tenantAccount, tenantName: data.contract.tenantName, fromTab: 'receipt_details', tenantAmount: Number(data.contract.tenantAmount) || 0, rent: Number(data.contract.rent) || 0, periodFrom: data.contract.periodFrom || '', periodTo: data.contract.periodTo || '', pdcAccount: selectedBuilding?.PDCAccount || '', cashAccount: selectedBuilding?.CashAccount || '' } })} className={`px-4 py-2 text-sm mt-6 font-semibold rounded-lg transition-all shadow-xs ${data.contract.tenantAccount && Number(data.contract.rent) > 0 ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-slate-200 text-slate-400 cursor-not-allowed'}`}>New Receipt</button>
                    </span>
                  </Tooltip>
                  <button type="button" onClick={() => navigate('/newReceipt', { state: { tenantCode: data.contract.tenantAccount, tenantName: data.contract.tenantName, fromTab: 'receipt_details', tenantAmount: Number(data.contract.rent) || 0, rent: Number(data.contract.rent) || 0, periodFrom: data.contract.periodFrom || '', periodTo: data.contract.periodTo || '', openModifyReceipt: true, receiptData: data.receipts, pdcAccount: selectedBuilding?.PDCAccount || '', cashAccount: selectedBuilding?.CashAccount || '' } })} className="px-4 py-2 bg-slate-700 hover:bg-slate-800 text-white text-sm mt-6 font-semibold rounded-lg transition-all shadow-xs">View/Modify Receipt</button>
                </div>
                {/* <button type="button" className="px-3 py-1.5 bg-amber-50 hover:bg-amber-100 text-amber-700 border border-amber-200 text-sm mt-6 font-semibold rounded-lg transition-all shadow-xs">Hold</button> */}
                {/* <button type="button" className="px-3 py-1.5 bg-emerald-50 hover:bg-emerald-100 text-emerald-700 border border-emerald-200 text-sm mt-6 font-semibold rounded-lg transition-all shadow-xs">Unhold</button> */}
                <button type="button" className="px-3 py-1.5 bg-red-50 hover:bg-red-100 text-red-700 border border-red-200 text-sm mt-6 font-semibold rounded-lg transition-all shadow-xs">Reverse</button>
                <button type="button" className="px-3 py-1.5 bg-blue-60 hover:bg-blue-100 text-blue-700 border border-blue-200  text-sm mt-6 font-semibold rounded-lg transition-all shadow-xs">PDC Transfers</button>
                {/* <button type="button" className="px-3 py-1.5 bg-green-100 hover:bg-green-200 text-green-700 border border-green-400 text-sm mt-6 font-semibold rounded-lg transition-all shadow-xs"> Bounce</button>
                <button type="button" className="px-3 py-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 border border-slate-200 text-sm mt-6 font-semibold rounded-lg transition-all shadow-xs"> Re-depo</button> */}
              </div>


              {/* <div className="overflow-x-auto border border-slate-200 rounded-xl">
                <table className="w-full text-left border-collapse text-xs">
                  <thead>
                    <tr className="bg-slate-50 border-b border-slate-200 text-slate-500 font-semibold uppercase tracking-wider">
                      <th className="p-3.5">SL</th>
                      <th className="p-3.5">Receipt No</th>
                      <th className="p-3.5">Date</th>
                      <th className="p-3.5">Description</th>
                      <th className="p-3.5 text-right">Amount</th>
                      <th className="p-3.5">Cheque No</th>
                      <th className="p-3.5">Cheque Date</th>
                      <th className="p-3.5">Bank</th>
                      <th className="p-3.5">Type</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 text-slate-700 font-mono">
                    {data.receipts.rows.map((row, index) => (
                      <tr key={index} className="hover:bg-slate-50/60 transition-colors">
                        <td className="p-3.5 font-sans text-slate-400">{row.slno}</td>
                        <td className="p-3.5 text-blue-600 font-sans font-medium">{row.rvNum}</td>
                        <td className="p-3.5">{row.date}</td>
                        <td className="p-3.5 text-slate-600 font-sans">{row.desc}</td>
                        <td className="p-3.5 text-right font-semibold text-slate-900">{row.amount.toLocaleString()}</td>
                        <td className="p-3.5 font-semibold text-slate-800">{row.chqNo}</td>
                        <td className="p-3.5 text-amber-600">{row.chqDate}</td>
                        <td className="p-3.5"><span className="bg-slate-100 px-1.5 py-0.5 rounded text-slate-600">{row.bank}</span></td>
                        <td className="p-3.5"><span className="bg-slate-100 px-1.5 py-0.5 rounded text-slate-600">{row.type}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div> */}

              <RecieptViewRE contractNo={data.header.contractNo} />


            </Card>
          </div>
        )}

        {/* TAB 5: OTHER INFORMATION UTILITIES LOGISTICS */}
        {activeTab === 'other_info' && (
          <div className="space-y-6 animate-fadeIn">
            <Card>
              <div className="max-w-xs">
                <h3 className="text-base font-semibold text-slate-800 w-[400px] mb-2">Shop ID</h3>
                <Input id="shopId" value={data.logistics.shopId} placeholder="e.g., RET-SHP-004" onChange={(e) => update('logistics', 'shopId', e.target.value)} />
              </div>
            </Card>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Card title="Electricity">
                <div className="space-y-4">
                  <Input label="Meter No" id="elecMeterNo" value={data.logistics.elecMeterNo} onChange={(e) => update('logistics', 'elecMeterNo', e.target.value)} />
                  <div className="grid grid-cols-3 gap-3">
                    <Input label="Open Reading" type="number" id="elecOpenReading" value={data.logistics.elecOpenReading} onChange={(e) => update('logistics', 'elecOpenReading', e.target.value)} />
                    <Input label="Meter Charge" id="elecMeterCharge" value={data.logistics.elecMeterCharge} onChange={(e) => update('logistics', 'elecMeterCharge', e.target.value)} />
                    <Input label="Rate" id="elecRate" value={data.logistics.elecRate} onChange={(e) => update('logistics', 'elecRate', e.target.value)} />
                  </div>
                </div>
              </Card>

              <Card title="Water">
                <div className="space-y-4">
                  <Input label="Meter No" id="waterMeterNo" value={data.logistics.waterMeterNo} onChange={(e) => update('logistics', 'waterMeterNo', e.target.value)} />
                  <div className="grid grid-cols-3 gap-3">
                    <Input label="Open Reading" type="number" id="waterOpenReading" value={data.logistics.waterOpenReading} onChange={(e) => update('logistics', 'waterOpenReading', e.target.value)} />
                    <Input label="Meter Charge" id="waterMeterCharge" value={data.logistics.waterMeterCharge} onChange={(e) => update('logistics', 'waterMeterCharge', e.target.value)} />
                    <Input label="Rate" id="waterRate" value={data.logistics.waterRate} onChange={(e) => update('logistics', 'waterRate', e.target.value)} />
                  </div>
                </div>
              </Card>
            </div>
          </div>
        )}

      </div>

      {/* Persistent Global Control Execution Footer Bar */}
      <div className="mx-auto mt-8 pt-4 border-t border-slate-200 flex flex-wrap items-center justify-between gap-4 pb-12">
        <div className="flex flex-wrap items-center gap-4">
          <div className="flex items-center gap-3">
            <span className="text-xs font-semibold text-slate-600">Select Print Mode:</span>
            <label className="flex items-center gap-1.5 cursor-pointer">
              <input type="radio" name="printSelection" value="P1" checked={data.printSelection === 'P1'} onChange={(e) => update('printSelection', null, e.target.value)} className="w-3.5 h-3.5 text-blue-600 border-slate-300 focus:ring-blue-500" />
              <span className="text-xs font-medium text-slate-700">P1</span>
            </label>
            <label className="flex items-center gap-1.5 cursor-pointer">
              <input type="radio" name="printSelection" value="P2" checked={data.printSelection === 'P2'} onChange={(e) => update('printSelection', null, e.target.value)} className="w-3.5 h-3.5 text-blue-600 border-slate-300 focus:ring-blue-500" />
              <span className="text-xs font-medium text-slate-700">P2</span>
            </label>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <button type="button" className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-semibold rounded-lg transition-all flex items-center gap-1.5">Print Contract</button>
            <button type="button" className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-semibold rounded-lg transition-all flex items-center gap-1.5">Print Details</button>
            <button type="button" className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-semibold rounded-lg transition-all flex items-center gap-1.5">Print Invoice</button>
            <button type="button" className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-semibold rounded-lg transition-all flex items-center gap-1.5">Print Renewal Notice</button>
          </div>

          <div className="flex items-center gap-2">
            <label className="text-xs font-semibold text-slate-600">Related Documents:</label>
            <label className="px-4 py-2 bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 text-xs font-semibold rounded-lg transition-all cursor-pointer flex items-center gap-1.5">
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" /></svg>
              Upload File
              <input type="file" multiple className="hidden" onChange={(e) => setData(prev => ({ ...prev, relatedDocs: [...prev.relatedDocs, ...Array.from(e.target.files)] }))} />
            </label>
            {data.relatedDocs.length > 0 && (
              <span className="text-[10px] text-slate-500 bg-slate-100 px-2 py-0.5 rounded-full">{data.relatedDocs.length} file(s) attached</span>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3 ml-auto w-full sm:w-auto justify-end">
          <button type="button" className="px-4 py-2 text-xs font-semibold text-slate-500 hover:text-slate-800 transition-colors">Discard</button>
          <button onClick={saveContractInformation} disabled={saving || !data.header.contractNo} type="button" className={`px-6 py-2 text-xs font-bold rounded-lg shadow-sm transition-all ${saving || !data.header.contractNo ? 'bg-slate-400 text-slate-200 cursor-not-allowed' : 'bg-slate-900 hover:bg-slate-800 text-white'}`}>
            <Tooltip title={!data.header.contractNo ? "Please enter a contract number" : ""} arrow placement="top">
              <span className="block">{saving ? "Saving..." : "Save Contract"}</span>
            </Tooltip>
          </button>
        </div>
      </div>

      {tenantModalOpen && (
        <Modal isOpen={tenantModalOpen} onClose={() => setTenantModalOpen(false)} title="Tenant List" size="xxl" header={true}>
          <CreditCustomerList defaultType="Customers" handleCustomerSelect={handleTenantSelect} />
        </Modal>
      )}

      {showDuplicateModal && (
        <Modal isOpen={showDuplicateModal} onClose={() => { setShowDuplicateModal(false); setDuplicateContractNo(""); }} title="Duplicate Contract" size="md" header={true}>
          <div className="p-6 flex flex-col items-center gap-4">
            <div className="text-sm text-slate-700 text-center">
              Contract number <span className="font-bold text-slate-900">{duplicateContractNo}</span> already exists.
            </div>
            <div className="text-xs text-slate-500 text-center">What would you like to do?</div>
            <div className="flex gap-3 mt-2">
              <button
                onClick={() => {
                  setShowDuplicateModal(false);
                  setDuplicateContractNo("");
                  update("header", "contractNo", "");
                }}
                className="px-5 py-2.5 text-sm font-semibold rounded-lg border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 transition-all"
              >
                Create New
              </button>
              <button
                onClick={() => {
                  const cNo = duplicateContractNo;
                  setShowDuplicateModal(false);
                  setDuplicateContractNo("");
                  fetchContractDetails(cNo);
                }}
                className="px-5 py-2.5 text-sm font-semibold rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-all"
              >
                Edit Existing
              </button>
            </div>
          </div>
        </Modal>
      )}



      {unitModalOpen && (
        <Modal isOpen={unitModalOpen} onClose={() => setUnitModalOpen(false)} title="Select Unit" size="xxl" header={true}>
          <div className="flex flex-col gap-4 p-6">
            {/* Search Bar */}
            <div className="flex items-center gap-3">
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input
                  type="text"
                  value={unitSearch}
                  onChange={(e) => setUnitSearch(e.target.value)}
                  placeholder="Search by Unit ID, Name, Type, Status..."
                  className="w-full pl-10 pr-4 py-2.5 text-sm border border-slate-200 rounded-xl bg-white focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 focus:outline-none"
                />
              </div>
            </div>

            {/* Units Table */}
            <div className="bg-white rounded-2xl border border-slate-200/80 shadow-sm flex-1 flex flex-col overflow-hidden">
              <div className="flex-1 overflow-x-auto">
                <table className="w-full  text-left border-collapse">
                  <thead className="bg-slate-200/60">
                    <tr className="bg-slate-50/50 border-b border-slate-100 text-[11px] font-bold text-slate-400 uppercase tracking-wider">
                      <th className="py-4 px-6 text-center w-12">Sl No</th>
                      <th className="py-4 px-4">Unit ID</th>
                      <th className="py-4 px-4">Unit No</th>
                      <th className="py-4 px-4">Unit Name</th>
                      <th className="py-4 px-4">Property Type</th>
                      <th className="py-4 px-4">Unit Type</th>
                      <th className="py-4 px-4">Category</th>
                      <th className="py-4 px-4">Status</th>
                      <th className="py-4 px-4">Bedrooms</th>
                      <th className="py-4 px-4">Bathrooms</th>
                      <th className="py-4 px-4">Annual Rent</th>
                      <th className="py-4 px-4">Monthly Rent</th>
                      <th className="py-4 px-4">Available From</th>
                      {/* <th className="py-4 px-4 text-center">Actions</th> */}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    {unitsLoading ? (
                      <tr>
                        <td colSpan={13} className="py-12 text-center text-sm text-slate-400 font-medium">
                          Loading units...
                        </td>
                      </tr>
                    ) : filteredUnits.length === 0 ? (
                      <tr>
                        <td colSpan={13} className="py-12 text-center text-sm text-slate-400 font-medium">
                          No units match current search query.
                        </td>
                      </tr>
                    ) : (
                      filteredUnits.map((unit, idx) => {
                        const unitId = unit.UnitID || unit.unit_id;
                        const unitNo = unit.UnitNo;
                        const unitName = unit.UnitName;
                        const propertyType = unit.PropertyType;
                        const unitType = unit.UnitType;
                        const category = unit.Category;
                        const unitStatus = unit.UnitStatus;
                        const bedrooms = unit.Bedrooms;
                        const bathrooms = unit.Bathrooms;
                        const annualRent = unit.AnnualRent;
                        const monthlyRent = unit.MonthlyRent;
                        const availabilityDate = unit.AvailabilityDate;

                        return (
                          <tr
                            key={unitId || idx}
                            onClick={(e) => { e.stopPropagation(); handleAddUnit(unit); }}

                            className="group hover:bg-blue-50/30 cursor-pointer transition-all"
                          >
                            <td className="py-4 px-6 text-center text-xs text-slate-400">
                              <span className="text-blue-600">{idx + 1}</span>
                            </td>
                            <td className="py-4 px-4 text-sm font-semibold text-slate-700">{unitId || '-'}</td>
                            <td className="py-4 px-4 text-sm text-slate-600">{unitNo || '-'}</td>
                            <td className="py-4 px-4 text-sm text-slate-600">{unitName || '-'}</td>
                            <td className="py-4 px-4 text-sm text-slate-600">{propertyType || '-'}</td>
                            <td className="py-4 px-4 text-sm text-slate-600">{unitType || '-'}</td>
                            <td className="py-4 px-4 text-sm text-slate-600">{category || '-'}</td>
                            <td className="py-4 px-4 text-sm text-slate-600">{unitStatus || '-'}</td>
                            <td className="py-4 px-4 text-sm text-slate-600">{bedrooms || '-'}</td>
                            <td className="py-4 px-4 text-sm text-slate-600">{bathrooms || '-'}</td>
                            <td className="py-4 px-4 text-sm text-slate-600">{annualRent || '-'}</td>
                            <td className="py-4 px-4 text-sm text-slate-600">{monthlyRent || '-'}</td>
                            <td className="py-4 px-4 text-sm text-slate-600">
                              {availabilityDate ? (isNaN(Date.parse(availabilityDate)) ? availabilityDate : new Date(availabilityDate).toLocaleDateString()) : '-'}
                            </td>
                            {/* <td className="py-4 px-4 text-center">
                              <button
                                onClick={(e) => { e.stopPropagation(); handleAddUnit(unit); }}
                                className="px-3 py-1.5 bg-emerald-600 hover:bg-emerald-700 active:scale-95 text-white font-bold text-[10px] uppercase tracking-wider rounded-lg transition-all flex items-center gap-1.5 mx-auto shadow-sm"
                              >
                                <Plus className="w-3 h-3" />
                                Select
                              </button>
                            </td> */}
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal>
      )}

    </div>
  );
}


